/* tslint:disable */
/* eslint-disable */
/**
 * stripe-gateway
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AddressInV2
 */
export interface AddressInV2 {
    /**
     * 
     * @type {string}
     * @memberof AddressInV2
     */
    'line1': string;
    /**
     * 
     * @type {string}
     * @memberof AddressInV2
     */
    'line2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressInV2
     */
    'postal_code': string;
    /**
     * 
     * @type {string}
     * @memberof AddressInV2
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof AddressInV2
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof AddressInV2
     */
    'country'?: string;
}
/**
 * 
 * @export
 * @interface AutoRejectOfferIn
 */
export interface AutoRejectOfferIn {
    /**
     * 
     * @type {boolean}
     * @memberof AutoRejectOfferIn
     */
    'is_dry_run': boolean;
}
/**
 * 
 * @export
 * @interface AutoRejectOfferOut
 */
export interface AutoRejectOfferOut {
    /**
     * 
     * @type {number}
     * @memberof AutoRejectOfferOut
     */
    'processed': number;
    /**
     * 
     * @type {number}
     * @memberof AutoRejectOfferOut
     */
    'errored': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AutoRejectOfferOut
     */
    'errored_usernames': Array<string>;
}
/**
 * 
 * @export
 * @interface AutoRenewalCancelIn
 */
export interface AutoRenewalCancelIn {
    /**
     * 
     * @type {string}
     * @memberof AutoRenewalCancelIn
     */
    'prefixed_order_number': string;
    /**
     * 
     * @type {ProductType}
     * @memberof AutoRenewalCancelIn
     */
    'product_type': ProductType;
}


/**
 * 
 * @export
 * @interface AutoRenewalCancelOut
 */
export interface AutoRenewalCancelOut {
    /**
     * 
     * @type {string}
     * @memberof AutoRenewalCancelOut
     */
    'end_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AutoRenewalCancelOut
     */
    'order_number': string;
}
/**
 * 
 * @export
 * @interface CancelAndRefundOrderOut
 */
export interface CancelAndRefundOrderOut {
    /**
     * 
     * @type {string}
     * @memberof CancelAndRefundOrderOut
     */
    'order_number': string;
    /**
     * 
     * @type {number}
     * @memberof CancelAndRefundOrderOut
     */
    'costs_incurred'?: number | null;
}
/**
 * 
 * @export
 * @interface CardDetails
 */
export interface CardDetails {
    /**
     * 
     * @type {string}
     * @memberof CardDetails
     */
    'last_4': string;
    /**
     * 
     * @type {string}
     * @memberof CardDetails
     */
    'brand': string;
    /**
     * 
     * @type {number}
     * @memberof CardDetails
     */
    'exp_month': number;
    /**
     * 
     * @type {number}
     * @memberof CardDetails
     */
    'exp_year': number;
}
/**
 * 
 * @export
 * @interface CheckoutPurchaseInV2
 */
export interface CheckoutPurchaseInV2 {
    /**
     * 
     * @type {string}
     * @memberof CheckoutPurchaseInV2
     */
    'purchase_country': string;
    /**
     * 
     * @type {Array<PurchaseItemV2>}
     * @memberof CheckoutPurchaseInV2
     */
    'items': Array<PurchaseItemV2>;
    /**
     * 
     * @type {string}
     * @memberof CheckoutPurchaseInV2
     */
    'promotion_code'?: string | null;
    /**
     * 
     * @type {CustomerInV2}
     * @memberof CheckoutPurchaseInV2
     */
    'customer': CustomerInV2;
    /**
     * 
     * @type {TaxData}
     * @memberof CheckoutPurchaseInV2
     */
    'tax_data': TaxData;
    /**
     * 
     * @type {string}
     * @memberof CheckoutPurchaseInV2
     */
    'fulfilment_cohort_id'?: string | null;
}
/**
 * 
 * @export
 * @interface CheckoutPurchaseInV3
 */
export interface CheckoutPurchaseInV3 {
    /**
     * 
     * @type {string}
     * @memberof CheckoutPurchaseInV3
     */
    'purchase_country': string;
    /**
     * 
     * @type {Array<PurchaseItemV3>}
     * @memberof CheckoutPurchaseInV3
     */
    'items': Array<PurchaseItemV3>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CheckoutPurchaseInV3
     */
    'promotion_codes'?: Array<string>;
    /**
     * 
     * @type {CustomerInV2}
     * @memberof CheckoutPurchaseInV3
     */
    'customer': CustomerInV2;
    /**
     * 
     * @type {TaxData}
     * @memberof CheckoutPurchaseInV3
     */
    'tax_data': TaxData;
    /**
     * 
     * @type {TermsConsentIn}
     * @memberof CheckoutPurchaseInV3
     */
    'terms_consent'?: TermsConsentIn | null;
}
/**
 * 
 * @export
 * @interface CheckoutSupplementaryPurchaseInV2
 */
export interface CheckoutSupplementaryPurchaseInV2 {
    /**
     * 
     * @type {string}
     * @memberof CheckoutSupplementaryPurchaseInV2
     */
    'purchase_country': string;
    /**
     * 
     * @type {Array<PurchaseItemV2>}
     * @memberof CheckoutSupplementaryPurchaseInV2
     */
    'items': Array<PurchaseItemV2>;
    /**
     * 
     * @type {string}
     * @memberof CheckoutSupplementaryPurchaseInV2
     */
    'promotion_code'?: string | null;
}
/**
 * 
 * @export
 * @interface CouponCreateIn
 */
export interface CouponCreateIn {
    /**
     * 
     * @type {number}
     * @memberof CouponCreateIn
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof CouponCreateIn
     */
    'name_prefix'?: string;
    /**
     * 
     * @type {CouponCreateInData}
     * @memberof CouponCreateIn
     */
    'data': CouponCreateInData;
}
/**
 * 
 * @export
 * @interface CouponCreateInData
 */
export interface CouponCreateInData {
    /**
     * 
     * @type {string}
     * @memberof CouponCreateInData
     */
    'country': CouponCreateInDataCountryEnum;
    /**
     * 
     * @type {Array<CouponDiscount>}
     * @memberof CouponCreateInData
     */
    'discounts': Array<CouponDiscount>;
    /**
     * 
     * @type {string}
     * @memberof CouponCreateInData
     */
    'expires_at'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CouponCreateInData
     */
    'max_redemptions'?: number | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CouponCreateInData
     */
    'metadata'?: { [key: string]: string; };
}

export const CouponCreateInDataCountryEnum = {
    Gb: 'GB',
    Us: 'US'
} as const;

export type CouponCreateInDataCountryEnum = typeof CouponCreateInDataCountryEnum[keyof typeof CouponCreateInDataCountryEnum];

/**
 * 
 * @export
 * @interface CouponCreateOut
 */
export interface CouponCreateOut {
    /**
     * 
     * @type {Array<CouponDetails>}
     * @memberof CouponCreateOut
     */
    'coupons': Array<CouponDetails>;
}
/**
 * 
 * @export
 * @interface CouponDetails
 */
export interface CouponDetails {
    /**
     * 
     * @type {string}
     * @memberof CouponDetails
     */
    'object'?: string;
    /**
     * 
     * @type {string}
     * @memberof CouponDetails
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CouponDetails
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CouponDiscount
 */
export interface CouponDiscount {
    /**
     * 
     * @type {DiscountProduct}
     * @memberof CouponDiscount
     */
    'product': DiscountProduct;
    /**
     * 
     * @type {number}
     * @memberof CouponDiscount
     */
    'percent_off'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CouponDiscount
     */
    'amount_off'?: number | null;
    /**
     * 
     * @type {CouponDuration}
     * @memberof CouponDiscount
     */
    'duration': CouponDuration;
}


/**
 * 
 * @export
 * @interface CouponDuration
 */
export interface CouponDuration {
    /**
     * 
     * @type {string}
     * @memberof CouponDuration
     */
    'type': CouponDurationTypeEnum;
}

export const CouponDurationTypeEnum = {
    MembershipCommitment: 'MEMBERSHIP_COMMITMENT',
    Once: 'ONCE',
    Forever: 'FOREVER'
} as const;

export type CouponDurationTypeEnum = typeof CouponDurationTypeEnum[keyof typeof CouponDurationTypeEnum];

/**
 * 
 * @export
 * @interface CouponV2
 */
export interface CouponV2 {
    /**
     * 
     * @type {string}
     * @memberof CouponV2
     */
    'id': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CouponV2
     */
    'metadata': { [key: string]: any; };
    /**
     * 
     * @type {number}
     * @memberof CouponV2
     */
    'amount_off': number;
    /**
     * 
     * @type {string}
     * @memberof CouponV2
     */
    'name'?: string | null;
    /**
     * 
     * @type {DiscountTypeV2}
     * @memberof CouponV2
     */
    'type': DiscountTypeV2;
    /**
     * 
     * @type {DiscountDurationV2}
     * @memberof CouponV2
     */
    'duration': DiscountDurationV2;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const Currency = {
    Gbp: 'gbp',
    Usd: 'usd'
} as const;

export type Currency = typeof Currency[keyof typeof Currency];


/**
 * 
 * @export
 * @interface CustomerDetails
 */
export interface CustomerDetails {
    /**
     * 
     * @type {StripeAddress}
     * @memberof CustomerDetails
     */
    'shipping_address': StripeAddress;
    /**
     * 
     * @type {string}
     * @memberof CustomerDetails
     */
    'shipping_name': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDetails
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerDetails
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerDetails
     */
    'card_last_4_digits'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerDetails
     */
    'email'?: string | null;
    /**
     * 
     * @type {ExistingOrderDetails}
     * @memberof CustomerDetails
     */
    'existing_order_details'?: ExistingOrderDetails | null;
    /**
     * 
     * @type {CardDetails}
     * @memberof CustomerDetails
     */
    'card_details'?: CardDetails | null;
    /**
     * 
     * @type {number}
     * @memberof CustomerDetails
     */
    'balance': number;
}
/**
 * 
 * @export
 * @interface CustomerDetailsSubscription
 */
export interface CustomerDetailsSubscription {
    /**
     * 
     * @type {ProductType}
     * @memberof CustomerDetailsSubscription
     */
    'product_type': ProductType;
    /**
     * 
     * @type {ZoeSubscriptionStatus}
     * @memberof CustomerDetailsSubscription
     */
    'status': ZoeSubscriptionStatus;
}


/**
 * 
 * @export
 * @interface CustomerDetailsWithOffer
 */
export interface CustomerDetailsWithOffer {
    /**
     * 
     * @type {StripeAddress}
     * @memberof CustomerDetailsWithOffer
     */
    'shipping_address': StripeAddress;
    /**
     * 
     * @type {string}
     * @memberof CustomerDetailsWithOffer
     */
    'shipping_name': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDetailsWithOffer
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerDetailsWithOffer
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerDetailsWithOffer
     */
    'card_last_4_digits'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerDetailsWithOffer
     */
    'email'?: string | null;
    /**
     * 
     * @type {ExistingOrderDetails}
     * @memberof CustomerDetailsWithOffer
     */
    'existing_order_details'?: ExistingOrderDetails | null;
    /**
     * 
     * @type {CardDetails}
     * @memberof CustomerDetailsWithOffer
     */
    'card_details'?: CardDetails | null;
    /**
     * 
     * @type {number}
     * @memberof CustomerDetailsWithOffer
     */
    'balance': number;
    /**
     * 
     * @type {OfferDetails}
     * @memberof CustomerDetailsWithOffer
     */
    'offer_details'?: OfferDetails | null;
}
/**
 * 
 * @export
 * @interface CustomerInV2
 */
export interface CustomerInV2 {
    /**
     * 
     * @type {string}
     * @memberof CustomerInV2
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerInV2
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerInV2
     */
    'last_name': string;
    /**
     * 
     * @type {AddressInV2}
     * @memberof CustomerInV2
     */
    'shipping_address': AddressInV2;
}
/**
 * 
 * @export
 * @interface Daily30AutoRenewalCancelOut
 */
export interface Daily30AutoRenewalCancelOut {
    /**
     * 
     * @type {string}
     * @memberof Daily30AutoRenewalCancelOut
     */
    'end_date': string;
    /**
     * 
     * @type {string}
     * @memberof Daily30AutoRenewalCancelOut
     */
    'order_number': string;
}
/**
 * 
 * @export
 * @interface DiscountDataV2
 */
export interface DiscountDataV2 {
    /**
     * 
     * @type {string}
     * @memberof DiscountDataV2
     */
    'submitted_promotion_code': string;
    /**
     * 
     * @type {CouponV2}
     * @memberof DiscountDataV2
     */
    'kit_coupon': CouponV2;
    /**
     * 
     * @type {CouponV2}
     * @memberof DiscountDataV2
     */
    'pay_now_coupon'?: CouponV2 | null;
    /**
     * 
     * @type {CouponV2}
     * @memberof DiscountDataV2
     */
    'membership_coupon'?: CouponV2 | null;
    /**
     * 
     * @type {CouponV2}
     * @memberof DiscountDataV2
     */
    'future_coupon'?: CouponV2 | null;
}
/**
 * 
 * @export
 * @interface DiscountDetailsV2
 */
export interface DiscountDetailsV2 {
    /**
     * 
     * @type {string}
     * @memberof DiscountDetailsV2
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof DiscountDetailsV2
     */
    'submitted_promotion_code'?: string | null;
    /**
     * 
     * @type {DiscountDurationV2}
     * @memberof DiscountDetailsV2
     */
    'duration': DiscountDurationV2;
    /**
     * 
     * @type {DiscountTypeV2}
     * @memberof DiscountDetailsV2
     */
    'discount_type': DiscountTypeV2;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DiscountDurationV2 = {
    Forever: 'forever',
    Once: 'once',
    Repeating: 'repeating'
} as const;

export type DiscountDurationV2 = typeof DiscountDurationV2[keyof typeof DiscountDurationV2];


/**
 * 
 * @export
 * @enum {string}
 */

export const DiscountProduct = {
    TestKit: 'TEST_KIT',
    Membership: 'MEMBERSHIP'
} as const;

export type DiscountProduct = typeof DiscountProduct[keyof typeof DiscountProduct];


/**
 * 
 * @export
 * @enum {string}
 */

export const DiscountTypeV2 = {
    Percent: 'percent',
    Amount: 'amount'
} as const;

export type DiscountTypeV2 = typeof DiscountTypeV2[keyof typeof DiscountTypeV2];


/**
 * 
 * @export
 * @interface DisputeDetails
 */
export interface DisputeDetails {
    /**
     * 
     * @type {string}
     * @memberof DisputeDetails
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof DisputeDetails
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof DisputeDetails
     */
    'reason': string;
}
/**
 * 
 * @export
 * @interface ExistingOrderDetails
 */
export interface ExistingOrderDetails {
    /**
     * 
     * @type {string}
     * @memberof ExistingOrderDetails
     */
    'stripe_customer_id': string;
    /**
     * 
     * @type {string}
     * @memberof ExistingOrderDetails
     */
    'stripe_country': string;
    /**
     * 
     * @type {Array<CustomerDetailsSubscription>}
     * @memberof ExistingOrderDetails
     */
    'subscriptions'?: Array<CustomerDetailsSubscription> | null;
}
/**
 * 
 * @export
 * @interface ExperimentOfferDetails
 */
export interface ExperimentOfferDetails {
    /**
     * 
     * @type {string}
     * @memberof ExperimentOfferDetails
     */
    'experiment_id': string;
    /**
     * 
     * @type {string}
     * @memberof ExperimentOfferDetails
     */
    'experiment_name': string;
    /**
     * 
     * @type {string}
     * @memberof ExperimentOfferDetails
     */
    'experiment_type': string;
    /**
     * 
     * @type {string}
     * @memberof ExperimentOfferDetails
     */
    'offer_status': string | null;
}
/**
 * 
 * @export
 * @interface FailureDetails
 */
export interface FailureDetails {
    /**
     * 
     * @type {string}
     * @memberof FailureDetails
     */
    'decline_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FailureDetails
     */
    'doc_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FailureDetails
     */
    'reason_showed_to_user'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FailureDetails
     */
    'next_retry_date'?: string | null;
}
/**
 * 
 * @export
 * @interface FulfilmentCohortOut
 */
export interface FulfilmentCohortOut {
    /**
     * 
     * @type {string}
     * @memberof FulfilmentCohortOut
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FulfilmentCohortOut
     */
    'fulfilment_date': string;
}
/**
 * 
 * @export
 * @interface GetLastRefundableChargeOut
 */
export interface GetLastRefundableChargeOut {
    /**
     * 
     * @type {ZoeCharge}
     * @memberof GetLastRefundableChargeOut
     */
    'charge': ZoeCharge | null;
}
/**
 * 
 * @export
 * @interface GetStripePortalUrlOut
 */
export interface GetStripePortalUrlOut {
    /**
     * 
     * @type {string}
     * @memberof GetStripePortalUrlOut
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * 
 * @export
 * @interface ListCustomerSubscriptionItemOut
 */
export interface ListCustomerSubscriptionItemOut {
    /**
     * 
     * @type {string}
     * @memberof ListCustomerSubscriptionItemOut
     */
    'prefixed_order_number': string;
    /**
     * 
     * @type {string}
     * @memberof ListCustomerSubscriptionItemOut
     */
    'product_id': string;
    /**
     * 
     * @type {ProductType}
     * @memberof ListCustomerSubscriptionItemOut
     */
    'product_type': ProductType;
    /**
     * 
     * @type {number}
     * @memberof ListCustomerSubscriptionItemOut
     */
    'commitment_duration_months': number;
    /**
     * 
     * @type {ZoeSubscriptionStatus}
     * @memberof ListCustomerSubscriptionItemOut
     */
    'status': ZoeSubscriptionStatus;
    /**
     * 
     * @type {string}
     * @memberof ListCustomerSubscriptionItemOut
     */
    'cancellation_date': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListCustomerSubscriptionItemOut
     */
    'commitment_end_date': string | null;
    /**
     * 
     * @type {ZoeSubscriptionRecurring}
     * @memberof ListCustomerSubscriptionItemOut
     */
    'recurring': ZoeSubscriptionRecurring;
    /**
     * 
     * @type {string}
     * @memberof ListCustomerSubscriptionItemOut
     */
    'next_payment_date'?: string | null;
    /**
     * 
     * @type {ZoeInvoice}
     * @memberof ListCustomerSubscriptionItemOut
     */
    'latest_invoice'?: ZoeInvoice | null;
}


/**
 * 
 * @export
 * @interface ListCustomerSubscriptionsOut
 */
export interface ListCustomerSubscriptionsOut {
    /**
     * 
     * @type {Array<ListCustomerSubscriptionItemOut>}
     * @memberof ListCustomerSubscriptionsOut
     */
    'subscriptions': Array<ListCustomerSubscriptionItemOut>;
}
/**
 * 
 * @export
 * @interface ListPricesV2Out
 */
export interface ListPricesV2Out {
    /**
     * 
     * @type {Array<PriceV2>}
     * @memberof ListPricesV2Out
     */
    'prices': Array<PriceV2>;
}
/**
 * 
 * @export
 * @interface LocationInner
 */
export interface LocationInner {
}
/**
 * 
 * @export
 * @interface MembershipAutoRenewalCancelIn
 */
export interface MembershipAutoRenewalCancelIn {
    /**
     * 
     * @type {string}
     * @memberof MembershipAutoRenewalCancelIn
     */
    'username': string;
}
/**
 * 
 * @export
 * @interface MembershipAutoRenewalSelfCancellationIn
 */
export interface MembershipAutoRenewalSelfCancellationIn {
    /**
     * 
     * @type {MembershipAutoRenewalSelfCancellationReason}
     * @memberof MembershipAutoRenewalSelfCancellationIn
     */
    'reason': MembershipAutoRenewalSelfCancellationReason;
    /**
     * 
     * @type {string}
     * @memberof MembershipAutoRenewalSelfCancellationIn
     */
    'reason_other'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const MembershipAutoRenewalSelfCancellationReason = {
    LearnedAll: 'LEARNED_ALL',
    NotUsing: 'NOT_USING',
    NotUsedMuch: 'NOT_USED_MUCH',
    NotHelpful: 'NOT_HELPFUL',
    NeedMoreProof: 'NEED_MORE_PROOF',
    TechnicalProblems: 'TECHNICAL_PROBLEMS',
    CannotAfford: 'CANNOT_AFFORD',
    NotGoodValue: 'NOT_GOOD_VALUE',
    UsingOtherService: 'USING_OTHER_SERVICE',
    Other: 'OTHER'
} as const;

export type MembershipAutoRenewalSelfCancellationReason = typeof MembershipAutoRenewalSelfCancellationReason[keyof typeof MembershipAutoRenewalSelfCancellationReason];


/**
 * 
 * @export
 * @interface MembershipCancelIn
 */
export interface MembershipCancelIn {
    /**
     * 
     * @type {string}
     * @memberof MembershipCancelIn
     */
    'username': string;
}
/**
 * 
 * @export
 * @interface MembershipCancelOut
 */
export interface MembershipCancelOut {
    /**
     * 
     * @type {MembershipRewardMonths}
     * @memberof MembershipCancelOut
     */
    'reward_months_cancelled': MembershipRewardMonths;
}
/**
 * 
 * @export
 * @interface MembershipOption
 */
export interface MembershipOption {
    /**
     * 
     * @type {string}
     * @memberof MembershipOption
     */
    'price_id': string;
    /**
     * 
     * @type {string}
     * @memberof MembershipOption
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof MembershipOption
     */
    'unit_amount': number;
    /**
     * 
     * @type {string}
     * @memberof MembershipOption
     */
    'currency': string;
}
/**
 * 
 * @export
 * @interface MembershipOut
 */
export interface MembershipOut {
    /**
     * 
     * @type {MembershipPhase}
     * @memberof MembershipOut
     */
    'current_phase': MembershipPhase;
    /**
     * 
     * @type {Array<MembershipPhase>}
     * @memberof MembershipOut
     */
    'future_phases': Array<MembershipPhase>;
    /**
     * 
     * @type {MembershipUpgradePrice}
     * @memberof MembershipOut
     */
    'upgrade_price'?: MembershipUpgradePrice | null;
    /**
     * 
     * @type {string}
     * @memberof MembershipOut
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof MembershipOut
     */
    'order_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MembershipOut
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MembershipOut
     */
    'cancellation_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MembershipOut
     */
    'next_payment_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MembershipOut
     */
    'cancellation_url'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MembershipOut
     */
    'next_payment_value'?: number | null;
}
/**
 * 
 * @export
 * @interface MembershipPhase
 */
export interface MembershipPhase {
    /**
     * 
     * @type {number}
     * @memberof MembershipPhase
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof MembershipPhase
     */
    'stripe_price_id': string;
    /**
     * 
     * @type {string}
     * @memberof MembershipPhase
     */
    'stripe_lookup_key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MembershipPhase
     */
    'start_date': string;
    /**
     * 
     * @type {string}
     * @memberof MembershipPhase
     */
    'end_date': string;
    /**
     * 
     * @type {string}
     * @memberof MembershipPhase
     */
    'currency': string;
    /**
     * 
     * @type {string}
     * @memberof MembershipPhase
     */
    'interval': string;
    /**
     * 
     * @type {number}
     * @memberof MembershipPhase
     */
    'interval_count': number;
    /**
     * 
     * @type {string}
     * @memberof MembershipPhase
     */
    'nickname': string;
    /**
     * 
     * @type {boolean}
     * @memberof MembershipPhase
     */
    'is_free_phase'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MembershipPhase
     */
    'referrer_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MembershipPhase
     */
    'total_free_months'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MembershipPhase
     */
    'coupon'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MembershipPhase
     */
    'forever_coupon_discount_price'?: number | null;
}
/**
 * 
 * @export
 * @interface MembershipPrice
 */
export interface MembershipPrice {
    /**
     * 
     * @type {number}
     * @memberof MembershipPrice
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof MembershipPrice
     */
    'stripe_price_id': string;
    /**
     * 
     * @type {string}
     * @memberof MembershipPrice
     */
    'stripe_lookup_key': string;
    /**
     * 
     * @type {string}
     * @memberof MembershipPrice
     */
    'currency': string;
    /**
     * 
     * @type {string}
     * @memberof MembershipPrice
     */
    'interval': string;
    /**
     * 
     * @type {number}
     * @memberof MembershipPrice
     */
    'interval_count': number;
    /**
     * 
     * @type {string}
     * @memberof MembershipPrice
     */
    'nickname': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof MembershipPrice
     */
    'metadata': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface MembershipReactivateIn
 */
export interface MembershipReactivateIn {
    /**
     * 
     * @type {string}
     * @memberof MembershipReactivateIn
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof MembershipReactivateIn
     */
    'price_lookup_key': string;
}
/**
 * 
 * @export
 * @interface MembershipReactivateOut
 */
export interface MembershipReactivateOut {
    /**
     * 
     * @type {PriceV2}
     * @memberof MembershipReactivateOut
     */
    'price': PriceV2;
    /**
     * 
     * @type {string}
     * @memberof MembershipReactivateOut
     */
    'start_date': string;
}
/**
 * 
 * @export
 * @interface MembershipRewardIn
 */
export interface MembershipRewardIn {
    /**
     * 
     * @type {number}
     * @memberof MembershipRewardIn
     */
    'months_to_add': number;
    /**
     * 
     * @type {RewardReason}
     * @memberof MembershipRewardIn
     */
    'reward_reason': RewardReason;
}


/**
 * 
 * @export
 * @interface MembershipRewardMonths
 */
export interface MembershipRewardMonths {
    /**
     * 
     * @type {number}
     * @memberof MembershipRewardMonths
     */
    'referrer_reward'?: number;
    /**
     * 
     * @type {number}
     * @memberof MembershipRewardMonths
     */
    'complementary'?: number;
    /**
     * 
     * @type {number}
     * @memberof MembershipRewardMonths
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface MembershipSwitchIn
 */
export interface MembershipSwitchIn {
    /**
     * 
     * @type {string}
     * @memberof MembershipSwitchIn
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof MembershipSwitchIn
     */
    'membership_option': string;
    /**
     * 
     * @type {boolean}
     * @memberof MembershipSwitchIn
     */
    'cancel_auto_renewal'?: boolean;
}
/**
 * 
 * @export
 * @interface MembershipSwitchOptionsOut
 */
export interface MembershipSwitchOptionsOut {
    /**
     * 
     * @type {MembershipOption}
     * @memberof MembershipSwitchOptionsOut
     */
    'current_membership': MembershipOption;
    /**
     * 
     * @type {Array<MembershipOption>}
     * @memberof MembershipSwitchOptionsOut
     */
    'membership_options': Array<MembershipOption>;
}
/**
 * 
 * @export
 * @interface MembershipSwitchOut
 */
export interface MembershipSwitchOut {
    /**
     * 
     * @type {string}
     * @memberof MembershipSwitchOut
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MembershipSwitchOut
     */
    'start_date': string;
    /**
     * 
     * @type {number}
     * @memberof MembershipSwitchOut
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof MembershipSwitchOut
     */
    'currency': string;
    /**
     * 
     * @type {string}
     * @memberof MembershipSwitchOut
     */
    'end_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MembershipSwitchOut
     */
    'refunded_amount'?: number | null;
}
/**
 * 
 * @export
 * @interface MembershipUpgradePrice
 */
export interface MembershipUpgradePrice {
    /**
     * 
     * @type {number}
     * @memberof MembershipUpgradePrice
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof MembershipUpgradePrice
     */
    'stripe_price_id': string;
    /**
     * 
     * @type {string}
     * @memberof MembershipUpgradePrice
     */
    'stripe_lookup_key': string;
    /**
     * 
     * @type {string}
     * @memberof MembershipUpgradePrice
     */
    'currency': string;
    /**
     * 
     * @type {string}
     * @memberof MembershipUpgradePrice
     */
    'interval': string;
    /**
     * 
     * @type {number}
     * @memberof MembershipUpgradePrice
     */
    'interval_count': number;
    /**
     * 
     * @type {string}
     * @memberof MembershipUpgradePrice
     */
    'nickname': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof MembershipUpgradePrice
     */
    'metadata'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface MicrobiomeRetestOfferMembershipOut
 */
export interface MicrobiomeRetestOfferMembershipOut {
    /**
     * 
     * @type {MembershipPrice}
     * @memberof MicrobiomeRetestOfferMembershipOut
     */
    'current_price': MembershipPrice;
    /**
     * 
     * @type {MembershipPrice}
     * @memberof MicrobiomeRetestOfferMembershipOut
     */
    'offer_price': MembershipPrice;
    /**
     * 
     * @type {string}
     * @memberof MicrobiomeRetestOfferMembershipOut
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof MicrobiomeRetestOfferMembershipOut
     */
    'order_number': string;
    /**
     * 
     * @type {CustomerDetails}
     * @memberof MicrobiomeRetestOfferMembershipOut
     */
    'customer_details': CustomerDetails;
    /**
     * 
     * @type {string}
     * @memberof MicrobiomeRetestOfferMembershipOut
     */
    'offer_status'?: string | null;
}
/**
 * 
 * @export
 * @interface OfferDetails
 */
export interface OfferDetails {
    /**
     * 
     * @type {string}
     * @memberof OfferDetails
     */
    'price_lookup_key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OfferDetails
     */
    'promotion_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OfferDetails
     */
    'expiry_date'?: string | null;
}
/**
 * 
 * @export
 * @interface OrderUpdateIn
 */
export interface OrderUpdateIn {
    /**
     * 
     * @type {OrderUpdateInActionEnum}
     * @memberof OrderUpdateIn
     */
    'action': OrderUpdateInActionEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderUpdateIn
     */
    'username': string;
    /**
     * 
     * @type {number}
     * @memberof OrderUpdateIn
     */
    'costs_incurred'?: number | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const OrderUpdateInActionEnum = {
    CancelAndRefund: 'cancel_and_refund',
    TestAction: 'TEST_ACTION'
} as const;

export type OrderUpdateInActionEnum = typeof OrderUpdateInActionEnum[keyof typeof OrderUpdateInActionEnum];


/**
 * 
 * @export
 * @interface PastPayment
 */
export interface PastPayment {
    /**
     * 
     * @type {string}
     * @memberof PastPayment
     */
    'payment_date': string;
    /**
     * 
     * @type {number}
     * @memberof PastPayment
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof PastPayment
     */
    'currency': string;
    /**
     * 
     * @type {string}
     * @memberof PastPayment
     */
    'payment_purpose': string;
    /**
     * 
     * @type {number}
     * @memberof PastPayment
     */
    'instalment_count'?: number | null;
    /**
     * 
     * @type {Array<RefundDetails>}
     * @memberof PastPayment
     */
    'refund_details'?: Array<RefundDetails> | null;
    /**
     * 
     * @type {FailureDetails}
     * @memberof PastPayment
     */
    'failure_details'?: FailureDetails | null;
    /**
     * 
     * @type {DisputeDetails}
     * @memberof PastPayment
     */
    'dispute_details'?: DisputeDetails | null;
}
/**
 * 
 * @export
 * @interface PaymentDetailsV2
 */
export interface PaymentDetailsV2 {
    /**
     * 
     * @type {string}
     * @memberof PaymentDetailsV2
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentDetailsV2
     */
    'client_secret': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentDetailsV2
     */
    'prefixed_order_number': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentDetailsV2
     */
    'currency': string;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsV2
     */
    'subtotal_amount': number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsV2
     */
    'tax_amount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsV2
     */
    'kit_amount': number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsV2
     */
    'pay_now_amount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsV2
     */
    'discount_amount'?: number | null;
    /**
     * 
     * @type {DiscountDetailsV2}
     * @memberof PaymentDetailsV2
     */
    'discount'?: DiscountDetailsV2 | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentDetailsV2
     */
    'customer': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentDetailsV2
     */
    'invoice': string;
    /**
     * 
     * @type {Array<PaymentLineItemV2>}
     * @memberof PaymentDetailsV2
     */
    'line_items': Array<PaymentLineItemV2>;
    /**
     * 
     * @type {string}
     * @memberof PaymentDetailsV2
     */
    'membership_schedule_id': string;
}
/**
 * 
 * @export
 * @interface PaymentDetailsV3
 */
export interface PaymentDetailsV3 {
    /**
     * 
     * @type {string}
     * @memberof PaymentDetailsV3
     */
    'currency': string;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsV3
     */
    'subtotal_amount': number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsV3
     */
    'total_amount': number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsV3
     */
    'tax_amount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsV3
     */
    'discount_amount'?: number | null;
    /**
     * 
     * @type {Array<PaymentLineItemV3>}
     * @memberof PaymentDetailsV3
     */
    'line_items': Array<PaymentLineItemV3>;
    /**
     * 
     * @type {string}
     * @memberof PaymentDetailsV3
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentDetailsV3
     */
    'client_secret': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentDetailsV3
     */
    'prefixed_order_number': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentDetailsV3
     */
    'customer': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentDetailsV3
     */
    'payment_method'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentDetailsV3
     */
    'invoice': string;
}
/**
 * 
 * @export
 * @interface PaymentErrorDetailsV2
 */
export interface PaymentErrorDetailsV2 {
    /**
     * 
     * @type {string}
     * @memberof PaymentErrorDetailsV2
     */
    'error_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentErrorDetailsV2
     */
    'error_type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentErrorDetailsV2
     */
    'decline_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentErrorDetailsV2
     */
    'payment_intent_status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentErrorDetailsV2
     */
    'payment_intent_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentErrorDetailsV2
     */
    'payment_method_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentErrorDetailsV2
     */
    'retry_error_message'?: string | null;
}
/**
 * 
 * @export
 * @interface PaymentLineItemV2
 */
export interface PaymentLineItemV2 {
    /**
     * 
     * @type {string}
     * @memberof PaymentLineItemV2
     */
    'product_name': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentLineItemV2
     */
    'zoe_product_id': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentLineItemV2
     */
    'item_type': string;
    /**
     * 
     * @type {number}
     * @memberof PaymentLineItemV2
     */
    'unit_amount': number;
    /**
     * 
     * @type {number}
     * @memberof PaymentLineItemV2
     */
    'discounted_unit_amount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaymentLineItemV2
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof PaymentLineItemV2
     */
    'timing': string;
    /**
     * 
     * @type {RecurringDetailsV2}
     * @memberof PaymentLineItemV2
     */
    'recurring'?: RecurringDetailsV2 | null;
    /**
     * 
     * @type {number}
     * @memberof PaymentLineItemV2
     */
    'commitment_months'?: number | null;
}
/**
 * 
 * @export
 * @interface PaymentLineItemV3
 */
export interface PaymentLineItemV3 {
    /**
     * 
     * @type {string}
     * @memberof PaymentLineItemV3
     */
    'product_name': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentLineItemV3
     */
    'zoe_product_id': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentLineItemV3
     */
    'item_type': string;
    /**
     * 
     * @type {number}
     * @memberof PaymentLineItemV3
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof PaymentLineItemV3
     */
    'unit_amount': number;
    /**
     * 
     * @type {number}
     * @memberof PaymentLineItemV3
     */
    'discounted_unit_amount'?: number | null;
    /**
     * 
     * @type {RecurringDetailsV2}
     * @memberof PaymentLineItemV3
     */
    'recurring'?: RecurringDetailsV2 | null;
    /**
     * 
     * @type {number}
     * @memberof PaymentLineItemV3
     */
    'commitment_months'?: number | null;
}
/**
 * 
 * @export
 * @interface PaymentsSummaryOut
 */
export interface PaymentsSummaryOut {
    /**
     * 
     * @type {Array<PastPayment>}
     * @memberof PaymentsSummaryOut
     */
    'payments': Array<PastPayment>;
    /**
     * 
     * @type {Array<UpcomingPaymentsInner>}
     * @memberof PaymentsSummaryOut
     */
    'upcoming_payments': Array<UpcomingPaymentsInner>;
}
/**
 * 
 * @export
 * @interface Price
 */
export interface Price {
    /**
     * 
     * @type {string}
     * @memberof Price
     */
    'currency': string;
    /**
     * 
     * @type {number}
     * @memberof Price
     */
    'unit_amount': number;
    /**
     * 
     * @type {string}
     * @memberof Price
     */
    'lookup_key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Price
     */
    'nickname'?: string | null;
    /**
     * 
     * @type {RecurringMetadata}
     * @memberof Price
     */
    'recurring'?: RecurringMetadata | null;
    /**
     * 
     * @type {string}
     * @memberof Price
     */
    'country': string;
    /**
     * 
     * @type {boolean}
     * @memberof Price
     */
    'pay_now': boolean;
    /**
     * 
     * @type {number}
     * @memberof Price
     */
    'instalment_count'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Price
     */
    'id': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Price
     */
    'metadata'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface PriceV2
 */
export interface PriceV2 {
    /**
     * 
     * @type {string}
     * @memberof PriceV2
     */
    'id': string;
    /**
     * 
     * @type {ProductType}
     * @memberof PriceV2
     */
    'product_type': ProductType;
    /**
     * 
     * @type {string}
     * @memberof PriceV2
     */
    'lookup_key': string;
    /**
     * 
     * @type {number}
     * @memberof PriceV2
     */
    'unit_amount': number;
    /**
     * 
     * @type {string}
     * @memberof PriceV2
     */
    'currency': string;
    /**
     * 
     * @type {string}
     * @memberof PriceV2
     */
    'name': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof PriceV2
     */
    'metadata': { [key: string]: any; };
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ProductType = {
    TestKit: 'Test kit',
    GutHealthRetest: 'Gut health retest',
    Program: 'Program',
    Daily30: 'Daily30'
} as const;

export type ProductType = typeof ProductType[keyof typeof ProductType];


/**
 * 
 * @export
 * @interface PurchaseItemV2
 */
export interface PurchaseItemV2 {
    /**
     * 
     * @type {string}
     * @memberof PurchaseItemV2
     */
    'zoe_product_id': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseItemV2
     */
    'stripe_price_id': string;
}
/**
 * 
 * @export
 * @interface PurchaseItemV3
 */
export interface PurchaseItemV3 {
    /**
     * 
     * @type {string}
     * @memberof PurchaseItemV3
     */
    'zoe_product_id': string;
}
/**
 * 
 * @export
 * @interface RecurringDetailsV2
 */
export interface RecurringDetailsV2 {
    /**
     * 
     * @type {string}
     * @memberof RecurringDetailsV2
     */
    'interval': string;
    /**
     * 
     * @type {number}
     * @memberof RecurringDetailsV2
     */
    'interval_count': number;
    /**
     * 
     * @type {number}
     * @memberof RecurringDetailsV2
     */
    'instalment_count'?: number | null;
}
/**
 * 
 * @export
 * @interface RecurringMetadata
 */
export interface RecurringMetadata {
    /**
     * 
     * @type {string}
     * @memberof RecurringMetadata
     */
    'interval': string;
    /**
     * 
     * @type {number}
     * @memberof RecurringMetadata
     */
    'interval_count': number;
}
/**
 * 
 * @export
 * @interface ReferralPhase
 */
export interface ReferralPhase {
    /**
     * 
     * @type {string}
     * @memberof ReferralPhase
     */
    'schedule_id': string;
    /**
     * 
     * @type {string}
     * @memberof ReferralPhase
     */
    'start_date': string;
    /**
     * 
     * @type {string}
     * @memberof ReferralPhase
     */
    'end_date': string;
}
/**
 * 
 * @export
 * @interface RefundChargeOut
 */
export interface RefundChargeOut {
    /**
     * 
     * @type {string}
     * @memberof RefundChargeOut
     */
    'refund_status': string;
    /**
     * 
     * @type {number}
     * @memberof RefundChargeOut
     */
    'refund_amount': number;
}
/**
 * 
 * @export
 * @interface RefundDaily30RecallBatchIn
 */
export interface RefundDaily30RecallBatchIn {
    /**
     * 
     * @type {boolean}
     * @memberof RefundDaily30RecallBatchIn
     */
    'is_dry_run'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RefundDaily30RecallBatchIn
     */
    'max_number_to_process'?: number;
}
/**
 * 
 * @export
 * @interface RefundDetails
 */
export interface RefundDetails {
    /**
     * 
     * @type {number}
     * @memberof RefundDetails
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof RefundDetails
     */
    'currency': string;
    /**
     * 
     * @type {string}
     * @memberof RefundDetails
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof RefundDetails
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface ResendAccountCompletionEmailOut
 */
export interface ResendAccountCompletionEmailOut {
    /**
     * 
     * @type {Array<string>}
     * @memberof ResendAccountCompletionEmailOut
     */
    'sent': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResendAccountCompletionEmailOut
     */
    'failed': Array<string>;
}
/**
 * 
 * @export
 * @interface ResendOrderConfirmationEmailOut
 */
export interface ResendOrderConfirmationEmailOut {
    /**
     * 
     * @type {Array<string>}
     * @memberof ResendOrderConfirmationEmailOut
     */
    'sent': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResendOrderConfirmationEmailOut
     */
    'failed': Array<string>;
}
/**
 * 
 * @export
 * @interface RestartSubscriptionDaily30IncidentOut
 */
export interface RestartSubscriptionDaily30IncidentOut {
    /**
     * 
     * @type {number}
     * @memberof RestartSubscriptionDaily30IncidentOut
     */
    'number_subscription_restarted': number;
    /**
     * 
     * @type {number}
     * @memberof RestartSubscriptionDaily30IncidentOut
     */
    'number_error': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const RewardReason = {
    ReferrerReward: 'referrer_reward',
    Complementary: 'complementary'
} as const;

export type RewardReason = typeof RewardReason[keyof typeof RewardReason];


/**
 * 
 * @export
 * @interface SelfCancellationUrl
 */
export interface SelfCancellationUrl {
    /**
     * 
     * @type {string}
     * @memberof SelfCancellationUrl
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface SendRestartEmailDaily30IncidentOut
 */
export interface SendRestartEmailDaily30IncidentOut {
    /**
     * 
     * @type {number}
     * @memberof SendRestartEmailDaily30IncidentOut
     */
    'number_email_sent': number;
    /**
     * 
     * @type {number}
     * @memberof SendRestartEmailDaily30IncidentOut
     */
    'number_error': number;
}
/**
 * 
 * @export
 * @interface StripeAddress
 */
export interface StripeAddress {
    /**
     * 
     * @type {string}
     * @memberof StripeAddress
     */
    'line1': string;
    /**
     * 
     * @type {string}
     * @memberof StripeAddress
     */
    'line2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StripeAddress
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof StripeAddress
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof StripeAddress
     */
    'postal_code': string;
    /**
     * 
     * @type {string}
     * @memberof StripeAddress
     */
    'country': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const StripeApiVersion = {
    _20200827: '2020-08-27',
    _20240620: '2024-06-20',
    _20241218Acacia: '2024-12-18.acacia'
} as const;

export type StripeApiVersion = typeof StripeApiVersion[keyof typeof StripeApiVersion];


/**
 * 
 * @export
 * @interface SubscriptionCancelIn
 */
export interface SubscriptionCancelIn {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionCancelIn
     */
    'prefixed_order_number': string;
}
/**
 * 
 * @export
 * @interface SubscriptionCancelOut
 */
export interface SubscriptionCancelOut {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionCancelOut
     */
    'prefixed_order_number': string;
}
/**
 * Request to pause a subscription.  If resumes_at is None, the subscription will be paused indefinitely until explicitly resumed. Otherwise, payments will automatically resume at the specified timestamp.  resumes_at: Integer UNIX timestamp (seconds since epoch) when the subscription should resume. charge_when_resumed: Boolean indicating whether to charge immediately when subscription is resumed.                     If True, the billing cycle anchor will be reset on resume. Defaults to True.
 * @export
 * @interface SubscriptionPauseIn
 */
export interface SubscriptionPauseIn {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPauseIn
     */
    'prefixed_order_number': string;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPauseIn
     */
    'resumes_at'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPauseIn
     */
    'charge_when_resumed'?: boolean;
}
/**
 * Response for a paused subscription.  paused_at: Integer UNIX timestamp (seconds since epoch) when the pause begins. resumes_at: Integer UNIX timestamp (seconds since epoch) when the subscription will resume, or None if paused indefinitely.
 * @export
 * @interface SubscriptionPauseOut
 */
export interface SubscriptionPauseOut {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPauseOut
     */
    'prefixed_order_number': string;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPauseOut
     */
    'paused_at': number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPauseOut
     */
    'resumes_at'?: number | null;
}
/**
 * 
 * @export
 * @interface SubscriptionUnpauseIn
 */
export interface SubscriptionUnpauseIn {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionUnpauseIn
     */
    'prefixed_order_number': string;
}
/**
 * 
 * @export
 * @interface SubscriptionUnpauseOut
 */
export interface SubscriptionUnpauseOut {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionUnpauseOut
     */
    'prefixed_order_number': string;
}
/**
 * 
 * @export
 * @interface SupplementaryOrderPaymentDetailsV2
 */
export interface SupplementaryOrderPaymentDetailsV2 {
    /**
     * 
     * @type {string}
     * @memberof SupplementaryOrderPaymentDetailsV2
     */
    'prefixed_order_number': string;
    /**
     * 
     * @type {string}
     * @memberof SupplementaryOrderPaymentDetailsV2
     */
    'customer_id': string;
    /**
     * 
     * @type {string}
     * @memberof SupplementaryOrderPaymentDetailsV2
     */
    'currency': string;
}
/**
 * 
 * @export
 * @interface TaxData
 */
export interface TaxData {
    /**
     * 
     * @type {number}
     * @memberof TaxData
     */
    'percentage': number;
    /**
     * 
     * @type {number}
     * @memberof TaxData
     */
    'tax_amount': number;
    /**
     * 
     * @type {boolean}
     * @memberof TaxData
     */
    'inclusive': boolean;
    /**
     * 
     * @type {string}
     * @memberof TaxData
     */
    'transaction_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaxData
     */
    'tax_rate_id'?: string | null;
}
/**
 * 
 * @export
 * @interface TermsConsentIn
 */
export interface TermsConsentIn {
    /**
     * 
     * @type {boolean}
     * @memberof TermsConsentIn
     */
    'has_consented': boolean;
    /**
     * 
     * @type {string}
     * @memberof TermsConsentIn
     */
    'consented_at': string;
}
/**
 * 
 * @export
 * @interface UpcomingPayment
 */
export interface UpcomingPayment {
    /**
     * 
     * @type {string}
     * @memberof UpcomingPayment
     */
    'payment_date': string;
    /**
     * 
     * @type {number}
     * @memberof UpcomingPayment
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof UpcomingPayment
     */
    'currency': string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingPayment
     */
    'payment_purpose': string;
    /**
     * 
     * @type {number}
     * @memberof UpcomingPayment
     */
    'instalment_count'?: number | null;
}
/**
 * 
 * @export
 * @interface UpcomingPaymentsInner
 */
export interface UpcomingPaymentsInner {
    /**
     * 
     * @type {string}
     * @memberof UpcomingPaymentsInner
     */
    'payment_date': string;
    /**
     * 
     * @type {number}
     * @memberof UpcomingPaymentsInner
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof UpcomingPaymentsInner
     */
    'currency': string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingPaymentsInner
     */
    'payment_purpose': string;
    /**
     * 
     * @type {number}
     * @memberof UpcomingPaymentsInner
     */
    'instalment_count'?: number | null;
}
/**
 * 
 * @export
 * @interface UpdateCancelledOrderLineItemStatusOut
 */
export interface UpdateCancelledOrderLineItemStatusOut {
    /**
     * 
     * @type {number}
     * @memberof UpdateCancelledOrderLineItemStatusOut
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateCancelledOrderLineItemStatusOut
     */
    'cancelled': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateCancelledOrderLineItemStatusOut
     */
    'skipped': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateCancelledOrderLineItemStatusOut
     */
    'errored': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateCancelledOrderLineItemStatusOut
     */
    'errored_order_numbers': Array<string>;
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<LocationInner>}
     * @memberof ValidationError
     */
    'loc': Array<LocationInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface ZoeCharge
 */
export interface ZoeCharge {
    /**
     * 
     * @type {string}
     * @memberof ZoeCharge
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ZoeCharge
     */
    'created_at': string;
    /**
     * 
     * @type {number}
     * @memberof ZoeCharge
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof ZoeCharge
     */
    'amount_captured': number;
    /**
     * 
     * @type {number}
     * @memberof ZoeCharge
     */
    'amount_refunded': number;
    /**
     * 
     * @type {string}
     * @memberof ZoeCharge
     */
    'currency': string;
    /**
     * 
     * @type {Array<ProductType>}
     * @memberof ZoeCharge
     */
    'product_types': Array<ProductType>;
}
/**
 * 
 * @export
 * @interface ZoeInvoice
 */
export interface ZoeInvoice {
    /**
     * 
     * @type {string}
     * @memberof ZoeInvoice
     */
    'due_date': string | null;
    /**
     * 
     * @type {Currency}
     * @memberof ZoeInvoice
     */
    'currency': Currency;
    /**
     * 
     * @type {number}
     * @memberof ZoeInvoice
     */
    'subtotal_amount': number;
    /**
     * 
     * @type {number}
     * @memberof ZoeInvoice
     */
    'tax_amount': number;
    /**
     * 
     * @type {number}
     * @memberof ZoeInvoice
     */
    'total_amount': number;
    /**
     * 
     * @type {Array<ZoeSubscriptionDiscount>}
     * @memberof ZoeInvoice
     */
    'discounts': Array<ZoeSubscriptionDiscount>;
}


/**
 * 
 * @export
 * @interface ZoeSubscriptionDiscount
 */
export interface ZoeSubscriptionDiscount {
    /**
     * 
     * @type {ZoeSubscriptionDiscountType}
     * @memberof ZoeSubscriptionDiscount
     */
    'type': ZoeSubscriptionDiscountType;
    /**
     * 
     * @type {string}
     * @memberof ZoeSubscriptionDiscount
     */
    'promotion_code': string | null;
    /**
     * 
     * @type {number}
     * @memberof ZoeSubscriptionDiscount
     */
    'amount': number;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ZoeSubscriptionDiscountType = {
    PromotionCode: 'promotion_code',
    MemberDiscount: 'member_discount'
} as const;

export type ZoeSubscriptionDiscountType = typeof ZoeSubscriptionDiscountType[keyof typeof ZoeSubscriptionDiscountType];


/**
 * 
 * @export
 * @interface ZoeSubscriptionRecurring
 */
export interface ZoeSubscriptionRecurring {
    /**
     * 
     * @type {ZoeSubscriptionRecurringInterval}
     * @memberof ZoeSubscriptionRecurring
     */
    'interval': ZoeSubscriptionRecurringInterval;
    /**
     * 
     * @type {number}
     * @memberof ZoeSubscriptionRecurring
     */
    'interval_count': number;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ZoeSubscriptionRecurringInterval = {
    Month: 'month',
    Year: 'year'
} as const;

export type ZoeSubscriptionRecurringInterval = typeof ZoeSubscriptionRecurringInterval[keyof typeof ZoeSubscriptionRecurringInterval];


/**
 * 
 * @export
 * @enum {string}
 */

export const ZoeSubscriptionStatus = {
    Active: 'active',
    Ended: 'ended',
    Paused: 'paused'
} as const;

export type ZoeSubscriptionStatus = typeof ZoeSubscriptionStatus[keyof typeof ZoeSubscriptionStatus];



/**
 * CheckoutApi - axios parameter creator
 * @export
 */
export const CheckoutApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cancel Order
         * @param {string} orderNumber 
         * @param {PaymentErrorDetailsV2} [paymentErrorDetailsV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrder: async (orderNumber: string, paymentErrorDetailsV2?: PaymentErrorDetailsV2, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderNumber' is not null or undefined
            assertParamExists('cancelOrder', 'orderNumber', orderNumber)
            const localVarPath = `/checkout/v2/orders/{order_number}/cancel`
                .replace(`{${"order_number"}}`, encodeURIComponent(String(orderNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentErrorDetailsV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel Order
         * @param {string} orderNumber 
         * @param {PaymentErrorDetailsV2} [paymentErrorDetailsV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrder_1: async (orderNumber: string, paymentErrorDetailsV2?: PaymentErrorDetailsV2, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderNumber' is not null or undefined
            assertParamExists('cancelOrder_1', 'orderNumber', orderNumber)
            const localVarPath = `/checkout/v3/orders/{order_number}/cancel`
                .replace(`{${"order_number"}}`, encodeURIComponent(String(orderNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentErrorDetailsV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create And Finalize Order
         * @param {CheckoutPurchaseInV2} checkoutPurchaseInV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAndFinalizeOrder: async (checkoutPurchaseInV2: CheckoutPurchaseInV2, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checkoutPurchaseInV2' is not null or undefined
            assertParamExists('createAndFinalizeOrder', 'checkoutPurchaseInV2', checkoutPurchaseInV2)
            const localVarPath = `/checkout/v2/orders/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkoutPurchaseInV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create And Finalize Order
         * @param {CheckoutPurchaseInV3} checkoutPurchaseInV3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAndFinalizeOrder_2: async (checkoutPurchaseInV3: CheckoutPurchaseInV3, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checkoutPurchaseInV3' is not null or undefined
            assertParamExists('createAndFinalizeOrder_2', 'checkoutPurchaseInV3', checkoutPurchaseInV3)
            const localVarPath = `/checkout/v3/orders/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkoutPurchaseInV3, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create And Finalize Supplementary Order
         * @param {string} username 
         * @param {CheckoutSupplementaryPurchaseInV2} checkoutSupplementaryPurchaseInV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAndFinalizeSupplementaryOrder: async (username: string, checkoutSupplementaryPurchaseInV2: CheckoutSupplementaryPurchaseInV2, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('createAndFinalizeSupplementaryOrder', 'username', username)
            // verify required parameter 'checkoutSupplementaryPurchaseInV2' is not null or undefined
            assertParamExists('createAndFinalizeSupplementaryOrder', 'checkoutSupplementaryPurchaseInV2', checkoutSupplementaryPurchaseInV2)
            const localVarPath = `/checkout/v2/orders/supplementary/customer/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkoutSupplementaryPurchaseInV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Customer Details
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDetails: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getCustomerDetails', 'username', username)
            const localVarPath = `/checkout/v2/customer_details/{username}/`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Discount Data
         * @param {string} promotionCode 
         * @param {string} stripeCountry 
         * @param {Array<string> | null} [onlyApplyToProducts] List of stripe product names that the promotion code is allowed to be used with, None means no restriction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscountData: async (promotionCode: string, stripeCountry: string, onlyApplyToProducts?: Array<string> | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'promotionCode' is not null or undefined
            assertParamExists('getDiscountData', 'promotionCode', promotionCode)
            // verify required parameter 'stripeCountry' is not null or undefined
            assertParamExists('getDiscountData', 'stripeCountry', stripeCountry)
            const localVarPath = `/checkout/v2/promotion-code/{stripe_country}/{promotion_code}/`
                .replace(`{${"promotion_code"}}`, encodeURIComponent(String(promotionCode)))
                .replace(`{${"stripe_country"}}`, encodeURIComponent(String(stripeCountry)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required

            if (onlyApplyToProducts) {
                localVarQueryParameter['only_apply_to_products'] = onlyApplyToProducts;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Tax Rate By Address
         * @param {string} stripeCountry 
         * @param {number} amount 
         * @param {string} zoeProductId 
         * @param {AddressInV2} addressInV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaxRateByAddress: async (stripeCountry: string, amount: number, zoeProductId: string, addressInV2: AddressInV2, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stripeCountry' is not null or undefined
            assertParamExists('getTaxRateByAddress', 'stripeCountry', stripeCountry)
            // verify required parameter 'amount' is not null or undefined
            assertParamExists('getTaxRateByAddress', 'amount', amount)
            // verify required parameter 'zoeProductId' is not null or undefined
            assertParamExists('getTaxRateByAddress', 'zoeProductId', zoeProductId)
            // verify required parameter 'addressInV2' is not null or undefined
            assertParamExists('getTaxRateByAddress', 'addressInV2', addressInV2)
            const localVarPath = `/checkout/v2/tax-rate/{stripe_country}/`
                .replace(`{${"stripe_country"}}`, encodeURIComponent(String(stripeCountry)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required

            if (amount !== undefined) {
                localVarQueryParameter['amount'] = amount;
            }

            if (zoeProductId !== undefined) {
                localVarQueryParameter['zoe_product_id'] = zoeProductId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addressInV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Tax Rate By Country
         * @param {string} stripeCountry 
         * @param {number} amount 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaxRateByCountry: async (stripeCountry: string, amount: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stripeCountry' is not null or undefined
            assertParamExists('getTaxRateByCountry', 'stripeCountry', stripeCountry)
            // verify required parameter 'amount' is not null or undefined
            assertParamExists('getTaxRateByCountry', 'amount', amount)
            const localVarPath = `/checkout/v2/tax-rate/{stripe_country}/`
                .replace(`{${"stripe_country"}}`, encodeURIComponent(String(stripeCountry)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required

            if (amount !== undefined) {
                localVarQueryParameter['amount'] = amount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CheckoutApi - functional programming interface
 * @export
 */
export const CheckoutApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CheckoutApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Cancel Order
         * @param {string} orderNumber 
         * @param {PaymentErrorDetailsV2} [paymentErrorDetailsV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelOrder(orderNumber: string, paymentErrorDetailsV2?: PaymentErrorDetailsV2, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelOrder(orderNumber, paymentErrorDetailsV2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CheckoutApi.cancelOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Cancel Order
         * @param {string} orderNumber 
         * @param {PaymentErrorDetailsV2} [paymentErrorDetailsV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelOrder_1(orderNumber: string, paymentErrorDetailsV2?: PaymentErrorDetailsV2, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelOrder_1(orderNumber, paymentErrorDetailsV2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CheckoutApi.cancelOrder_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create And Finalize Order
         * @param {CheckoutPurchaseInV2} checkoutPurchaseInV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAndFinalizeOrder(checkoutPurchaseInV2: CheckoutPurchaseInV2, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentDetailsV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAndFinalizeOrder(checkoutPurchaseInV2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CheckoutApi.createAndFinalizeOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create And Finalize Order
         * @param {CheckoutPurchaseInV3} checkoutPurchaseInV3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAndFinalizeOrder_2(checkoutPurchaseInV3: CheckoutPurchaseInV3, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentDetailsV3>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAndFinalizeOrder_2(checkoutPurchaseInV3, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CheckoutApi.createAndFinalizeOrder_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create And Finalize Supplementary Order
         * @param {string} username 
         * @param {CheckoutSupplementaryPurchaseInV2} checkoutSupplementaryPurchaseInV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAndFinalizeSupplementaryOrder(username: string, checkoutSupplementaryPurchaseInV2: CheckoutSupplementaryPurchaseInV2, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupplementaryOrderPaymentDetailsV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAndFinalizeSupplementaryOrder(username, checkoutSupplementaryPurchaseInV2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CheckoutApi.createAndFinalizeSupplementaryOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Customer Details
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerDetails(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerDetailsWithOffer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerDetails(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CheckoutApi.getCustomerDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Discount Data
         * @param {string} promotionCode 
         * @param {string} stripeCountry 
         * @param {Array<string> | null} [onlyApplyToProducts] List of stripe product names that the promotion code is allowed to be used with, None means no restriction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDiscountData(promotionCode: string, stripeCountry: string, onlyApplyToProducts?: Array<string> | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiscountDataV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDiscountData(promotionCode, stripeCountry, onlyApplyToProducts, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CheckoutApi.getDiscountData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Tax Rate By Address
         * @param {string} stripeCountry 
         * @param {number} amount 
         * @param {string} zoeProductId 
         * @param {AddressInV2} addressInV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTaxRateByAddress(stripeCountry: string, amount: number, zoeProductId: string, addressInV2: AddressInV2, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTaxRateByAddress(stripeCountry, amount, zoeProductId, addressInV2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CheckoutApi.getTaxRateByAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Tax Rate By Country
         * @param {string} stripeCountry 
         * @param {number} amount 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTaxRateByCountry(stripeCountry: string, amount: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTaxRateByCountry(stripeCountry, amount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CheckoutApi.getTaxRateByCountry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CheckoutApi - factory interface
 * @export
 */
export const CheckoutApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CheckoutApiFp(configuration)
    return {
        /**
         * 
         * @summary Cancel Order
         * @param {string} orderNumber 
         * @param {PaymentErrorDetailsV2} [paymentErrorDetailsV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrder(orderNumber: string, paymentErrorDetailsV2?: PaymentErrorDetailsV2, options?: any): AxiosPromise<any> {
            return localVarFp.cancelOrder(orderNumber, paymentErrorDetailsV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel Order
         * @param {string} orderNumber 
         * @param {PaymentErrorDetailsV2} [paymentErrorDetailsV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrder_1(orderNumber: string, paymentErrorDetailsV2?: PaymentErrorDetailsV2, options?: any): AxiosPromise<any> {
            return localVarFp.cancelOrder_1(orderNumber, paymentErrorDetailsV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create And Finalize Order
         * @param {CheckoutPurchaseInV2} checkoutPurchaseInV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAndFinalizeOrder(checkoutPurchaseInV2: CheckoutPurchaseInV2, options?: any): AxiosPromise<PaymentDetailsV2> {
            return localVarFp.createAndFinalizeOrder(checkoutPurchaseInV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create And Finalize Order
         * @param {CheckoutPurchaseInV3} checkoutPurchaseInV3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAndFinalizeOrder_2(checkoutPurchaseInV3: CheckoutPurchaseInV3, options?: any): AxiosPromise<PaymentDetailsV3> {
            return localVarFp.createAndFinalizeOrder_2(checkoutPurchaseInV3, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create And Finalize Supplementary Order
         * @param {string} username 
         * @param {CheckoutSupplementaryPurchaseInV2} checkoutSupplementaryPurchaseInV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAndFinalizeSupplementaryOrder(username: string, checkoutSupplementaryPurchaseInV2: CheckoutSupplementaryPurchaseInV2, options?: any): AxiosPromise<SupplementaryOrderPaymentDetailsV2> {
            return localVarFp.createAndFinalizeSupplementaryOrder(username, checkoutSupplementaryPurchaseInV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Customer Details
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDetails(username: string, options?: any): AxiosPromise<CustomerDetailsWithOffer> {
            return localVarFp.getCustomerDetails(username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Discount Data
         * @param {string} promotionCode 
         * @param {string} stripeCountry 
         * @param {Array<string> | null} [onlyApplyToProducts] List of stripe product names that the promotion code is allowed to be used with, None means no restriction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscountData(promotionCode: string, stripeCountry: string, onlyApplyToProducts?: Array<string> | null, options?: any): AxiosPromise<DiscountDataV2> {
            return localVarFp.getDiscountData(promotionCode, stripeCountry, onlyApplyToProducts, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Tax Rate By Address
         * @param {string} stripeCountry 
         * @param {number} amount 
         * @param {string} zoeProductId 
         * @param {AddressInV2} addressInV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaxRateByAddress(stripeCountry: string, amount: number, zoeProductId: string, addressInV2: AddressInV2, options?: any): AxiosPromise<TaxData> {
            return localVarFp.getTaxRateByAddress(stripeCountry, amount, zoeProductId, addressInV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Tax Rate By Country
         * @param {string} stripeCountry 
         * @param {number} amount 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaxRateByCountry(stripeCountry: string, amount: number, options?: any): AxiosPromise<TaxData> {
            return localVarFp.getTaxRateByCountry(stripeCountry, amount, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CheckoutApi - object-oriented interface
 * @export
 * @class CheckoutApi
 * @extends {BaseAPI}
 */
export class CheckoutApi extends BaseAPI {
    /**
     * 
     * @summary Cancel Order
     * @param {string} orderNumber 
     * @param {PaymentErrorDetailsV2} [paymentErrorDetailsV2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckoutApi
     */
    public cancelOrder(orderNumber: string, paymentErrorDetailsV2?: PaymentErrorDetailsV2, options?: RawAxiosRequestConfig) {
        return CheckoutApiFp(this.configuration).cancelOrder(orderNumber, paymentErrorDetailsV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel Order
     * @param {string} orderNumber 
     * @param {PaymentErrorDetailsV2} [paymentErrorDetailsV2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckoutApi
     */
    public cancelOrder_1(orderNumber: string, paymentErrorDetailsV2?: PaymentErrorDetailsV2, options?: RawAxiosRequestConfig) {
        return CheckoutApiFp(this.configuration).cancelOrder_1(orderNumber, paymentErrorDetailsV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create And Finalize Order
     * @param {CheckoutPurchaseInV2} checkoutPurchaseInV2 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckoutApi
     */
    public createAndFinalizeOrder(checkoutPurchaseInV2: CheckoutPurchaseInV2, options?: RawAxiosRequestConfig) {
        return CheckoutApiFp(this.configuration).createAndFinalizeOrder(checkoutPurchaseInV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create And Finalize Order
     * @param {CheckoutPurchaseInV3} checkoutPurchaseInV3 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckoutApi
     */
    public createAndFinalizeOrder_2(checkoutPurchaseInV3: CheckoutPurchaseInV3, options?: RawAxiosRequestConfig) {
        return CheckoutApiFp(this.configuration).createAndFinalizeOrder_2(checkoutPurchaseInV3, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create And Finalize Supplementary Order
     * @param {string} username 
     * @param {CheckoutSupplementaryPurchaseInV2} checkoutSupplementaryPurchaseInV2 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckoutApi
     */
    public createAndFinalizeSupplementaryOrder(username: string, checkoutSupplementaryPurchaseInV2: CheckoutSupplementaryPurchaseInV2, options?: RawAxiosRequestConfig) {
        return CheckoutApiFp(this.configuration).createAndFinalizeSupplementaryOrder(username, checkoutSupplementaryPurchaseInV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Customer Details
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckoutApi
     */
    public getCustomerDetails(username: string, options?: RawAxiosRequestConfig) {
        return CheckoutApiFp(this.configuration).getCustomerDetails(username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Discount Data
     * @param {string} promotionCode 
     * @param {string} stripeCountry 
     * @param {Array<string> | null} [onlyApplyToProducts] List of stripe product names that the promotion code is allowed to be used with, None means no restriction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckoutApi
     */
    public getDiscountData(promotionCode: string, stripeCountry: string, onlyApplyToProducts?: Array<string> | null, options?: RawAxiosRequestConfig) {
        return CheckoutApiFp(this.configuration).getDiscountData(promotionCode, stripeCountry, onlyApplyToProducts, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Tax Rate By Address
     * @param {string} stripeCountry 
     * @param {number} amount 
     * @param {string} zoeProductId 
     * @param {AddressInV2} addressInV2 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckoutApi
     */
    public getTaxRateByAddress(stripeCountry: string, amount: number, zoeProductId: string, addressInV2: AddressInV2, options?: RawAxiosRequestConfig) {
        return CheckoutApiFp(this.configuration).getTaxRateByAddress(stripeCountry, amount, zoeProductId, addressInV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Tax Rate By Country
     * @param {string} stripeCountry 
     * @param {number} amount 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckoutApi
     */
    public getTaxRateByCountry(stripeCountry: string, amount: number, options?: RawAxiosRequestConfig) {
        return CheckoutApiFp(this.configuration).getTaxRateByCountry(stripeCountry, amount, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CohortApi - axios parameter creator
 * @export
 */
export const CohortApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Earliest Open Cohort
         * @param {string} cohortType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        earliestOpenCohort: async (cohortType: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cohortType' is not null or undefined
            assertParamExists('earliestOpenCohort', 'cohortType', cohortType)
            const localVarPath = `/cohort/{cohort_type}/earliest-open`
                .replace(`{${"cohort_type"}}`, encodeURIComponent(String(cohortType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CohortApi - functional programming interface
 * @export
 */
export const CohortApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CohortApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Earliest Open Cohort
         * @param {string} cohortType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async earliestOpenCohort(cohortType: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FulfilmentCohortOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.earliestOpenCohort(cohortType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CohortApi.earliestOpenCohort']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CohortApi - factory interface
 * @export
 */
export const CohortApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CohortApiFp(configuration)
    return {
        /**
         * 
         * @summary Earliest Open Cohort
         * @param {string} cohortType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        earliestOpenCohort(cohortType: string, options?: any): AxiosPromise<FulfilmentCohortOut> {
            return localVarFp.earliestOpenCohort(cohortType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CohortApi - object-oriented interface
 * @export
 * @class CohortApi
 * @extends {BaseAPI}
 */
export class CohortApi extends BaseAPI {
    /**
     * 
     * @summary Earliest Open Cohort
     * @param {string} cohortType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CohortApi
     */
    public earliestOpenCohort(cohortType: string, options?: RawAxiosRequestConfig) {
        return CohortApiFp(this.configuration).earliestOpenCohort(cohortType, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CouponApi - axios parameter creator
 * @export
 */
export const CouponApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Coupons
         * @param {CouponCreateIn} couponCreateIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCoupons: async (couponCreateIn: CouponCreateIn, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'couponCreateIn' is not null or undefined
            assertParamExists('createCoupons', 'couponCreateIn', couponCreateIn)
            const localVarPath = `/v1/coupon/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(couponCreateIn, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CouponApi - functional programming interface
 * @export
 */
export const CouponApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CouponApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Coupons
         * @param {CouponCreateIn} couponCreateIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCoupons(couponCreateIn: CouponCreateIn, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CouponCreateOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCoupons(couponCreateIn, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponApi.createCoupons']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CouponApi - factory interface
 * @export
 */
export const CouponApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CouponApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Coupons
         * @param {CouponCreateIn} couponCreateIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCoupons(couponCreateIn: CouponCreateIn, options?: any): AxiosPromise<CouponCreateOut> {
            return localVarFp.createCoupons(couponCreateIn, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CouponApi - object-oriented interface
 * @export
 * @class CouponApi
 * @extends {BaseAPI}
 */
export class CouponApi extends BaseAPI {
    /**
     * 
     * @summary Create Coupons
     * @param {CouponCreateIn} couponCreateIn 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponApi
     */
    public createCoupons(couponCreateIn: CouponCreateIn, options?: RawAxiosRequestConfig) {
        return CouponApiFp(this.configuration).createCoupons(couponCreateIn, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomerApi - axios parameter creator
 * @export
 */
export const CustomerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Customer Details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDetails: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Last Refundable Charge
         * @param {string} username 
         * @param {ProductType} productType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastRefundableCharge: async (username: string, productType: ProductType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getLastRefundableCharge', 'username', username)
            // verify required parameter 'productType' is not null or undefined
            assertParamExists('getLastRefundableCharge', 'productType', productType)
            const localVarPath = `/customer/{username}/last-refundable-charge`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required

            if (productType !== undefined) {
                localVarQueryParameter['product_type'] = productType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerApi - functional programming interface
 * @export
 */
export const CustomerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Customer Details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerDetails(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerDetails(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.getCustomerDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Last Refundable Charge
         * @param {string} username 
         * @param {ProductType} productType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLastRefundableCharge(username: string, productType: ProductType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLastRefundableChargeOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLastRefundableCharge(username, productType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.getLastRefundableCharge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomerApi - factory interface
 * @export
 */
export const CustomerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Customer Details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDetails(options?: any): AxiosPromise<CustomerDetails> {
            return localVarFp.getCustomerDetails(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Last Refundable Charge
         * @param {string} username 
         * @param {ProductType} productType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastRefundableCharge(username: string, productType: ProductType, options?: any): AxiosPromise<GetLastRefundableChargeOut> {
            return localVarFp.getLastRefundableCharge(username, productType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerApi - object-oriented interface
 * @export
 * @class CustomerApi
 * @extends {BaseAPI}
 */
export class CustomerApi extends BaseAPI {
    /**
     * 
     * @summary Get Customer Details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getCustomerDetails(options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).getCustomerDetails(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Last Refundable Charge
     * @param {string} username 
     * @param {ProductType} productType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getLastRefundableCharge(username: string, productType: ProductType, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).getLastRefundableCharge(username, productType, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * Daily30IncidentApi - axios parameter creator
 * @export
 */
export const Daily30IncidentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Process Refund Daily30 Incident
         * @param {RefundDaily30RecallBatchIn} refundDaily30RecallBatchIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processRefundDaily30Incident: async (refundDaily30RecallBatchIn: RefundDaily30RecallBatchIn, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'refundDaily30RecallBatchIn' is not null or undefined
            assertParamExists('processRefundDaily30Incident', 'refundDaily30RecallBatchIn', refundDaily30RecallBatchIn)
            const localVarPath = `/daily30-incident/tasks/process-refund-daily30-incident`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refundDaily30RecallBatchIn, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Process Restart Subscription Daily30 Incident
         * @param {boolean} [isDryRun] 
         * @param {number | null} [maxNumberToProcess] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processRestartSubscriptionDaily30Incident: async (isDryRun?: boolean, maxNumberToProcess?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/daily30-incident/tasks/daily30-incident-restart-subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required

            if (isDryRun !== undefined) {
                localVarQueryParameter['is_dry_run'] = isDryRun;
            }

            if (maxNumberToProcess !== undefined) {
                localVarQueryParameter['max_number_to_process'] = maxNumberToProcess;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Process Send Restart Email Daily30 Incident
         * @param {boolean} [isDryRun] 
         * @param {number | null} [maxNumberToProcess] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processSendRestartEmailDaily30Incident: async (isDryRun?: boolean, maxNumberToProcess?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/daily30-incident/tasks/daily30-incident-send-restart-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required

            if (isDryRun !== undefined) {
                localVarQueryParameter['is_dry_run'] = isDryRun;
            }

            if (maxNumberToProcess !== undefined) {
                localVarQueryParameter['max_number_to_process'] = maxNumberToProcess;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Daily30IncidentApi - functional programming interface
 * @export
 */
export const Daily30IncidentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = Daily30IncidentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Process Refund Daily30 Incident
         * @param {RefundDaily30RecallBatchIn} refundDaily30RecallBatchIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processRefundDaily30Incident(refundDaily30RecallBatchIn: RefundDaily30RecallBatchIn, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.processRefundDaily30Incident(refundDaily30RecallBatchIn, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Daily30IncidentApi.processRefundDaily30Incident']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Process Restart Subscription Daily30 Incident
         * @param {boolean} [isDryRun] 
         * @param {number | null} [maxNumberToProcess] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processRestartSubscriptionDaily30Incident(isDryRun?: boolean, maxNumberToProcess?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RestartSubscriptionDaily30IncidentOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.processRestartSubscriptionDaily30Incident(isDryRun, maxNumberToProcess, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Daily30IncidentApi.processRestartSubscriptionDaily30Incident']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Process Send Restart Email Daily30 Incident
         * @param {boolean} [isDryRun] 
         * @param {number | null} [maxNumberToProcess] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processSendRestartEmailDaily30Incident(isDryRun?: boolean, maxNumberToProcess?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendRestartEmailDaily30IncidentOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.processSendRestartEmailDaily30Incident(isDryRun, maxNumberToProcess, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Daily30IncidentApi.processSendRestartEmailDaily30Incident']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * Daily30IncidentApi - factory interface
 * @export
 */
export const Daily30IncidentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = Daily30IncidentApiFp(configuration)
    return {
        /**
         * 
         * @summary Process Refund Daily30 Incident
         * @param {RefundDaily30RecallBatchIn} refundDaily30RecallBatchIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processRefundDaily30Incident(refundDaily30RecallBatchIn: RefundDaily30RecallBatchIn, options?: any): AxiosPromise<any> {
            return localVarFp.processRefundDaily30Incident(refundDaily30RecallBatchIn, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Process Restart Subscription Daily30 Incident
         * @param {boolean} [isDryRun] 
         * @param {number | null} [maxNumberToProcess] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processRestartSubscriptionDaily30Incident(isDryRun?: boolean, maxNumberToProcess?: number | null, options?: any): AxiosPromise<RestartSubscriptionDaily30IncidentOut> {
            return localVarFp.processRestartSubscriptionDaily30Incident(isDryRun, maxNumberToProcess, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Process Send Restart Email Daily30 Incident
         * @param {boolean} [isDryRun] 
         * @param {number | null} [maxNumberToProcess] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processSendRestartEmailDaily30Incident(isDryRun?: boolean, maxNumberToProcess?: number | null, options?: any): AxiosPromise<SendRestartEmailDaily30IncidentOut> {
            return localVarFp.processSendRestartEmailDaily30Incident(isDryRun, maxNumberToProcess, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Daily30IncidentApi - object-oriented interface
 * @export
 * @class Daily30IncidentApi
 * @extends {BaseAPI}
 */
export class Daily30IncidentApi extends BaseAPI {
    /**
     * 
     * @summary Process Refund Daily30 Incident
     * @param {RefundDaily30RecallBatchIn} refundDaily30RecallBatchIn 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Daily30IncidentApi
     */
    public processRefundDaily30Incident(refundDaily30RecallBatchIn: RefundDaily30RecallBatchIn, options?: RawAxiosRequestConfig) {
        return Daily30IncidentApiFp(this.configuration).processRefundDaily30Incident(refundDaily30RecallBatchIn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Process Restart Subscription Daily30 Incident
     * @param {boolean} [isDryRun] 
     * @param {number | null} [maxNumberToProcess] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Daily30IncidentApi
     */
    public processRestartSubscriptionDaily30Incident(isDryRun?: boolean, maxNumberToProcess?: number | null, options?: RawAxiosRequestConfig) {
        return Daily30IncidentApiFp(this.configuration).processRestartSubscriptionDaily30Incident(isDryRun, maxNumberToProcess, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Process Send Restart Email Daily30 Incident
     * @param {boolean} [isDryRun] 
     * @param {number | null} [maxNumberToProcess] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Daily30IncidentApi
     */
    public processSendRestartEmailDaily30Incident(isDryRun?: boolean, maxNumberToProcess?: number | null, options?: RawAxiosRequestConfig) {
        return Daily30IncidentApiFp(this.configuration).processSendRestartEmailDaily30Incident(isDryRun, maxNumberToProcess, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ExperimentApi - axios parameter creator
 * @export
 */
export const ExperimentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Auto Reject Offer
         * @param {AutoRejectOfferIn} autoRejectOfferIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoRejectOffer: async (autoRejectOfferIn: AutoRejectOfferIn, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'autoRejectOfferIn' is not null or undefined
            assertParamExists('autoRejectOffer', 'autoRejectOfferIn', autoRejectOfferIn)
            const localVarPath = `/experiment/tasks/auto-reject-offer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(autoRejectOfferIn, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Extend Experiment Offer
         * @param {string} username 
         * @param {string} experimentId 
         * @param {number} days 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extendExperimentOffer: async (username: string, experimentId: string, days: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('extendExperimentOffer', 'username', username)
            // verify required parameter 'experimentId' is not null or undefined
            assertParamExists('extendExperimentOffer', 'experimentId', experimentId)
            // verify required parameter 'days' is not null or undefined
            assertParamExists('extendExperimentOffer', 'days', days)
            const localVarPath = `/experiment/extend-experiment-offer/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }

            if (experimentId !== undefined) {
                localVarQueryParameter['experiment_id'] = experimentId;
            }

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get All Experiment Offer Details By Username
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllExperimentOfferDetailsByUsername: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getAllExperimentOfferDetailsByUsername', 'username', username)
            const localVarPath = `/experiment/experiment_offer_details/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Line Item Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLineItemStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/experiment/tasks/update_cancelled_order_line_item_status_1st_ghr_exp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExperimentApi - functional programming interface
 * @export
 */
export const ExperimentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExperimentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Auto Reject Offer
         * @param {AutoRejectOfferIn} autoRejectOfferIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autoRejectOffer(autoRejectOfferIn: AutoRejectOfferIn, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AutoRejectOfferOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autoRejectOffer(autoRejectOfferIn, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExperimentApi.autoRejectOffer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Extend Experiment Offer
         * @param {string} username 
         * @param {string} experimentId 
         * @param {number} days 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async extendExperimentOffer(username: string, experimentId: string, days: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.extendExperimentOffer(username, experimentId, days, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExperimentApi.extendExperimentOffer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get All Experiment Offer Details By Username
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllExperimentOfferDetailsByUsername(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExperimentOfferDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllExperimentOfferDetailsByUsername(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExperimentApi.getAllExperimentOfferDetailsByUsername']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Line Item Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLineItemStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateCancelledOrderLineItemStatusOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLineItemStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExperimentApi.updateLineItemStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExperimentApi - factory interface
 * @export
 */
export const ExperimentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExperimentApiFp(configuration)
    return {
        /**
         * 
         * @summary Auto Reject Offer
         * @param {AutoRejectOfferIn} autoRejectOfferIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoRejectOffer(autoRejectOfferIn: AutoRejectOfferIn, options?: any): AxiosPromise<AutoRejectOfferOut> {
            return localVarFp.autoRejectOffer(autoRejectOfferIn, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Extend Experiment Offer
         * @param {string} username 
         * @param {string} experimentId 
         * @param {number} days 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extendExperimentOffer(username: string, experimentId: string, days: number, options?: any): AxiosPromise<any> {
            return localVarFp.extendExperimentOffer(username, experimentId, days, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get All Experiment Offer Details By Username
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllExperimentOfferDetailsByUsername(username: string, options?: any): AxiosPromise<Array<ExperimentOfferDetails>> {
            return localVarFp.getAllExperimentOfferDetailsByUsername(username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Line Item Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLineItemStatus(options?: any): AxiosPromise<UpdateCancelledOrderLineItemStatusOut> {
            return localVarFp.updateLineItemStatus(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExperimentApi - object-oriented interface
 * @export
 * @class ExperimentApi
 * @extends {BaseAPI}
 */
export class ExperimentApi extends BaseAPI {
    /**
     * 
     * @summary Auto Reject Offer
     * @param {AutoRejectOfferIn} autoRejectOfferIn 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExperimentApi
     */
    public autoRejectOffer(autoRejectOfferIn: AutoRejectOfferIn, options?: RawAxiosRequestConfig) {
        return ExperimentApiFp(this.configuration).autoRejectOffer(autoRejectOfferIn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Extend Experiment Offer
     * @param {string} username 
     * @param {string} experimentId 
     * @param {number} days 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExperimentApi
     */
    public extendExperimentOffer(username: string, experimentId: string, days: number, options?: RawAxiosRequestConfig) {
        return ExperimentApiFp(this.configuration).extendExperimentOffer(username, experimentId, days, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get All Experiment Offer Details By Username
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExperimentApi
     */
    public getAllExperimentOfferDetailsByUsername(username: string, options?: RawAxiosRequestConfig) {
        return ExperimentApiFp(this.configuration).getAllExperimentOfferDetailsByUsername(username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Line Item Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExperimentApi
     */
    public updateLineItemStatus(options?: RawAxiosRequestConfig) {
        return ExperimentApiFp(this.configuration).updateLineItemStatus(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MembershipApi - axios parameter creator
 * @export
 */
export const MembershipApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add Reward Months
         * @param {string} username 
         * @param {MembershipRewardIn} membershipRewardIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRewardMonths: async (username: string, membershipRewardIn: MembershipRewardIn, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('addRewardMonths', 'username', username)
            // verify required parameter 'membershipRewardIn' is not null or undefined
            assertParamExists('addRewardMonths', 'membershipRewardIn', membershipRewardIn)
            const localVarPath = `/membership/add-free-months/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(membershipRewardIn, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel Membership
         * @param {MembershipCancelIn} membershipCancelIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelMembership: async (membershipCancelIn: MembershipCancelIn, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'membershipCancelIn' is not null or undefined
            assertParamExists('cancelMembership', 'membershipCancelIn', membershipCancelIn)
            const localVarPath = `/membership/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(membershipCancelIn, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel Membership Auto Renewal
         * @param {string} orderNumber 
         * @param {MembershipAutoRenewalCancelIn} membershipAutoRenewalCancelIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelMembershipAutoRenewal: async (orderNumber: string, membershipAutoRenewalCancelIn: MembershipAutoRenewalCancelIn, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderNumber' is not null or undefined
            assertParamExists('cancelMembershipAutoRenewal', 'orderNumber', orderNumber)
            // verify required parameter 'membershipAutoRenewalCancelIn' is not null or undefined
            assertParamExists('cancelMembershipAutoRenewal', 'membershipAutoRenewalCancelIn', membershipAutoRenewalCancelIn)
            const localVarPath = `/membership/{order_number}/auto-renewal/cancel`
                .replace(`{${"order_number"}}`, encodeURIComponent(String(orderNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(membershipAutoRenewalCancelIn, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Membership By Username
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMembershipByUsername: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getMembershipByUsername', 'username', username)
            const localVarPath = `/membership/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Membership Information By Username
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMembershipInformationByUsername: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getMembershipInformationByUsername', 'username', username)
            const localVarPath = `/membership/v2/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Membership Switch Options
         * @param {string} orderNumber 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMembershipSwitchOptions: async (orderNumber: string, username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderNumber' is not null or undefined
            assertParamExists('listMembershipSwitchOptions', 'orderNumber', orderNumber)
            // verify required parameter 'username' is not null or undefined
            assertParamExists('listMembershipSwitchOptions', 'username', username)
            const localVarPath = `/membership/{order_number}/options/`
                .replace(`{${"order_number"}}`, encodeURIComponent(String(orderNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reactivate Membership
         * @param {MembershipReactivateIn} membershipReactivateIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateMembership: async (membershipReactivateIn: MembershipReactivateIn, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'membershipReactivateIn' is not null or undefined
            assertParamExists('reactivateMembership', 'membershipReactivateIn', membershipReactivateIn)
            const localVarPath = `/membership/reactivate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(membershipReactivateIn, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Switch Membership
         * @param {string} orderNumber 
         * @param {MembershipSwitchIn} membershipSwitchIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        switchMembership: async (orderNumber: string, membershipSwitchIn: MembershipSwitchIn, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderNumber' is not null or undefined
            assertParamExists('switchMembership', 'orderNumber', orderNumber)
            // verify required parameter 'membershipSwitchIn' is not null or undefined
            assertParamExists('switchMembership', 'membershipSwitchIn', membershipSwitchIn)
            const localVarPath = `/membership/{order_number}`
                .replace(`{${"order_number"}}`, encodeURIComponent(String(orderNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(membershipSwitchIn, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MembershipApi - functional programming interface
 * @export
 */
export const MembershipApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MembershipApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add Reward Months
         * @param {string} username 
         * @param {MembershipRewardIn} membershipRewardIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addRewardMonths(username: string, membershipRewardIn: MembershipRewardIn, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferralPhase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addRewardMonths(username, membershipRewardIn, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MembershipApi.addRewardMonths']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Cancel Membership
         * @param {MembershipCancelIn} membershipCancelIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelMembership(membershipCancelIn: MembershipCancelIn, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MembershipCancelOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelMembership(membershipCancelIn, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MembershipApi.cancelMembership']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Cancel Membership Auto Renewal
         * @param {string} orderNumber 
         * @param {MembershipAutoRenewalCancelIn} membershipAutoRenewalCancelIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelMembershipAutoRenewal(orderNumber: string, membershipAutoRenewalCancelIn: MembershipAutoRenewalCancelIn, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AutoRenewalCancelOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelMembershipAutoRenewal(orderNumber, membershipAutoRenewalCancelIn, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MembershipApi.cancelMembershipAutoRenewal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Membership By Username
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMembershipByUsername(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MembershipOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMembershipByUsername(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MembershipApi.getMembershipByUsername']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Membership Information By Username
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMembershipInformationByUsername(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCustomerSubscriptionsOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMembershipInformationByUsername(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MembershipApi.getMembershipInformationByUsername']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Membership Switch Options
         * @param {string} orderNumber 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMembershipSwitchOptions(orderNumber: string, username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MembershipSwitchOptionsOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMembershipSwitchOptions(orderNumber, username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MembershipApi.listMembershipSwitchOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reactivate Membership
         * @param {MembershipReactivateIn} membershipReactivateIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reactivateMembership(membershipReactivateIn: MembershipReactivateIn, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MembershipReactivateOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reactivateMembership(membershipReactivateIn, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MembershipApi.reactivateMembership']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Switch Membership
         * @param {string} orderNumber 
         * @param {MembershipSwitchIn} membershipSwitchIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async switchMembership(orderNumber: string, membershipSwitchIn: MembershipSwitchIn, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MembershipSwitchOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.switchMembership(orderNumber, membershipSwitchIn, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MembershipApi.switchMembership']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MembershipApi - factory interface
 * @export
 */
export const MembershipApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MembershipApiFp(configuration)
    return {
        /**
         * 
         * @summary Add Reward Months
         * @param {string} username 
         * @param {MembershipRewardIn} membershipRewardIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRewardMonths(username: string, membershipRewardIn: MembershipRewardIn, options?: any): AxiosPromise<ReferralPhase> {
            return localVarFp.addRewardMonths(username, membershipRewardIn, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel Membership
         * @param {MembershipCancelIn} membershipCancelIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelMembership(membershipCancelIn: MembershipCancelIn, options?: any): AxiosPromise<MembershipCancelOut> {
            return localVarFp.cancelMembership(membershipCancelIn, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel Membership Auto Renewal
         * @param {string} orderNumber 
         * @param {MembershipAutoRenewalCancelIn} membershipAutoRenewalCancelIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelMembershipAutoRenewal(orderNumber: string, membershipAutoRenewalCancelIn: MembershipAutoRenewalCancelIn, options?: any): AxiosPromise<AutoRenewalCancelOut> {
            return localVarFp.cancelMembershipAutoRenewal(orderNumber, membershipAutoRenewalCancelIn, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Membership By Username
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMembershipByUsername(username: string, options?: any): AxiosPromise<MembershipOut> {
            return localVarFp.getMembershipByUsername(username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Membership Information By Username
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMembershipInformationByUsername(username: string, options?: any): AxiosPromise<ListCustomerSubscriptionsOut> {
            return localVarFp.getMembershipInformationByUsername(username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Membership Switch Options
         * @param {string} orderNumber 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMembershipSwitchOptions(orderNumber: string, username: string, options?: any): AxiosPromise<MembershipSwitchOptionsOut> {
            return localVarFp.listMembershipSwitchOptions(orderNumber, username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reactivate Membership
         * @param {MembershipReactivateIn} membershipReactivateIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateMembership(membershipReactivateIn: MembershipReactivateIn, options?: any): AxiosPromise<MembershipReactivateOut> {
            return localVarFp.reactivateMembership(membershipReactivateIn, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Switch Membership
         * @param {string} orderNumber 
         * @param {MembershipSwitchIn} membershipSwitchIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        switchMembership(orderNumber: string, membershipSwitchIn: MembershipSwitchIn, options?: any): AxiosPromise<MembershipSwitchOut> {
            return localVarFp.switchMembership(orderNumber, membershipSwitchIn, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MembershipApi - object-oriented interface
 * @export
 * @class MembershipApi
 * @extends {BaseAPI}
 */
export class MembershipApi extends BaseAPI {
    /**
     * 
     * @summary Add Reward Months
     * @param {string} username 
     * @param {MembershipRewardIn} membershipRewardIn 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembershipApi
     */
    public addRewardMonths(username: string, membershipRewardIn: MembershipRewardIn, options?: RawAxiosRequestConfig) {
        return MembershipApiFp(this.configuration).addRewardMonths(username, membershipRewardIn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel Membership
     * @param {MembershipCancelIn} membershipCancelIn 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembershipApi
     */
    public cancelMembership(membershipCancelIn: MembershipCancelIn, options?: RawAxiosRequestConfig) {
        return MembershipApiFp(this.configuration).cancelMembership(membershipCancelIn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel Membership Auto Renewal
     * @param {string} orderNumber 
     * @param {MembershipAutoRenewalCancelIn} membershipAutoRenewalCancelIn 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembershipApi
     */
    public cancelMembershipAutoRenewal(orderNumber: string, membershipAutoRenewalCancelIn: MembershipAutoRenewalCancelIn, options?: RawAxiosRequestConfig) {
        return MembershipApiFp(this.configuration).cancelMembershipAutoRenewal(orderNumber, membershipAutoRenewalCancelIn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Membership By Username
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembershipApi
     */
    public getMembershipByUsername(username: string, options?: RawAxiosRequestConfig) {
        return MembershipApiFp(this.configuration).getMembershipByUsername(username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Membership Information By Username
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembershipApi
     */
    public getMembershipInformationByUsername(username: string, options?: RawAxiosRequestConfig) {
        return MembershipApiFp(this.configuration).getMembershipInformationByUsername(username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Membership Switch Options
     * @param {string} orderNumber 
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembershipApi
     */
    public listMembershipSwitchOptions(orderNumber: string, username: string, options?: RawAxiosRequestConfig) {
        return MembershipApiFp(this.configuration).listMembershipSwitchOptions(orderNumber, username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reactivate Membership
     * @param {MembershipReactivateIn} membershipReactivateIn 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembershipApi
     */
    public reactivateMembership(membershipReactivateIn: MembershipReactivateIn, options?: RawAxiosRequestConfig) {
        return MembershipApiFp(this.configuration).reactivateMembership(membershipReactivateIn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Switch Membership
     * @param {string} orderNumber 
     * @param {MembershipSwitchIn} membershipSwitchIn 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembershipApi
     */
    public switchMembership(orderNumber: string, membershipSwitchIn: MembershipSwitchIn, options?: RawAxiosRequestConfig) {
        return MembershipApiFp(this.configuration).switchMembership(orderNumber, membershipSwitchIn, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MicrobiomeRetestApi - axios parameter creator
 * @export
 */
export const MicrobiomeRetestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Microbiome Retest Offer For Username
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMicrobiomeRetestOfferForUsername: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('createMicrobiomeRetestOfferForUsername', 'username', username)
            const localVarPath = `/microbiome-retest/membership/username/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Microbiome Retest Offer For Username
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMicrobiomeRetestOfferForUsername: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getMicrobiomeRetestOfferForUsername', 'username', username)
            const localVarPath = `/microbiome-retest/membership/username/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reject Microbiome Retest Offer For Username
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectMicrobiomeRetestOfferForUsername: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('rejectMicrobiomeRetestOfferForUsername', 'username', username)
            const localVarPath = `/microbiome-retest/membership/username/{username}/reject`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MicrobiomeRetestApi - functional programming interface
 * @export
 */
export const MicrobiomeRetestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MicrobiomeRetestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Microbiome Retest Offer For Username
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMicrobiomeRetestOfferForUsername(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MembershipOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMicrobiomeRetestOfferForUsername(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MicrobiomeRetestApi.createMicrobiomeRetestOfferForUsername']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Microbiome Retest Offer For Username
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMicrobiomeRetestOfferForUsername(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MicrobiomeRetestOfferMembershipOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMicrobiomeRetestOfferForUsername(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MicrobiomeRetestApi.getMicrobiomeRetestOfferForUsername']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reject Microbiome Retest Offer For Username
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectMicrobiomeRetestOfferForUsername(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectMicrobiomeRetestOfferForUsername(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MicrobiomeRetestApi.rejectMicrobiomeRetestOfferForUsername']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MicrobiomeRetestApi - factory interface
 * @export
 */
export const MicrobiomeRetestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MicrobiomeRetestApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Microbiome Retest Offer For Username
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMicrobiomeRetestOfferForUsername(username: string, options?: any): AxiosPromise<MembershipOut> {
            return localVarFp.createMicrobiomeRetestOfferForUsername(username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Microbiome Retest Offer For Username
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMicrobiomeRetestOfferForUsername(username: string, options?: any): AxiosPromise<MicrobiomeRetestOfferMembershipOut> {
            return localVarFp.getMicrobiomeRetestOfferForUsername(username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reject Microbiome Retest Offer For Username
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectMicrobiomeRetestOfferForUsername(username: string, options?: any): AxiosPromise<any> {
            return localVarFp.rejectMicrobiomeRetestOfferForUsername(username, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MicrobiomeRetestApi - object-oriented interface
 * @export
 * @class MicrobiomeRetestApi
 * @extends {BaseAPI}
 */
export class MicrobiomeRetestApi extends BaseAPI {
    /**
     * 
     * @summary Create Microbiome Retest Offer For Username
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MicrobiomeRetestApi
     */
    public createMicrobiomeRetestOfferForUsername(username: string, options?: RawAxiosRequestConfig) {
        return MicrobiomeRetestApiFp(this.configuration).createMicrobiomeRetestOfferForUsername(username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Microbiome Retest Offer For Username
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MicrobiomeRetestApi
     */
    public getMicrobiomeRetestOfferForUsername(username: string, options?: RawAxiosRequestConfig) {
        return MicrobiomeRetestApiFp(this.configuration).getMicrobiomeRetestOfferForUsername(username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reject Microbiome Retest Offer For Username
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MicrobiomeRetestApi
     */
    public rejectMicrobiomeRetestOfferForUsername(username: string, options?: RawAxiosRequestConfig) {
        return MicrobiomeRetestApiFp(this.configuration).rejectMicrobiomeRetestOfferForUsername(username, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrderApi - axios parameter creator
 * @export
 */
export const OrderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete Stale Order Measurement Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStaleOrderMeasurementData: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/order/tasks/delete-stale-order-measurement-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resend Account Completion Email
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendAccountCompletionEmail: async (requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('resendAccountCompletionEmail', 'requestBody', requestBody)
            const localVarPath = `/order/tasks/resend-account-completion-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resend Order Confirmation Email
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendOrderConfirmationEmail: async (requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('resendOrderConfirmationEmail', 'requestBody', requestBody)
            const localVarPath = `/order/tasks/resend-order-confirmation-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Order
         * @param {string} orderNumber 
         * @param {OrderUpdateIn} orderUpdateIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrder: async (orderNumber: string, orderUpdateIn: OrderUpdateIn, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderNumber' is not null or undefined
            assertParamExists('updateOrder', 'orderNumber', orderNumber)
            // verify required parameter 'orderUpdateIn' is not null or undefined
            assertParamExists('updateOrder', 'orderUpdateIn', orderUpdateIn)
            const localVarPath = `/order/{order_number}/`
                .replace(`{${"order_number"}}`, encodeURIComponent(String(orderNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderUpdateIn, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderApi - functional programming interface
 * @export
 */
export const OrderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete Stale Order Measurement Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteStaleOrderMeasurementData(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteStaleOrderMeasurementData(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.deleteStaleOrderMeasurementData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Resend Account Completion Email
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendAccountCompletionEmail(requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResendAccountCompletionEmailOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendAccountCompletionEmail(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.resendAccountCompletionEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Resend Order Confirmation Email
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendOrderConfirmationEmail(requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResendOrderConfirmationEmailOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendOrderConfirmationEmail(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.resendOrderConfirmationEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Order
         * @param {string} orderNumber 
         * @param {OrderUpdateIn} orderUpdateIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrder(orderNumber: string, orderUpdateIn: OrderUpdateIn, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CancelAndRefundOrderOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrder(orderNumber, orderUpdateIn, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.updateOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrderApi - factory interface
 * @export
 */
export const OrderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete Stale Order Measurement Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStaleOrderMeasurementData(options?: any): AxiosPromise<any> {
            return localVarFp.deleteStaleOrderMeasurementData(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resend Account Completion Email
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendAccountCompletionEmail(requestBody: Array<string>, options?: any): AxiosPromise<ResendAccountCompletionEmailOut> {
            return localVarFp.resendAccountCompletionEmail(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resend Order Confirmation Email
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendOrderConfirmationEmail(requestBody: Array<string>, options?: any): AxiosPromise<ResendOrderConfirmationEmailOut> {
            return localVarFp.resendOrderConfirmationEmail(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Order
         * @param {string} orderNumber 
         * @param {OrderUpdateIn} orderUpdateIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrder(orderNumber: string, orderUpdateIn: OrderUpdateIn, options?: any): AxiosPromise<CancelAndRefundOrderOut> {
            return localVarFp.updateOrder(orderNumber, orderUpdateIn, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderApi - object-oriented interface
 * @export
 * @class OrderApi
 * @extends {BaseAPI}
 */
export class OrderApi extends BaseAPI {
    /**
     * 
     * @summary Delete Stale Order Measurement Data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public deleteStaleOrderMeasurementData(options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).deleteStaleOrderMeasurementData(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resend Account Completion Email
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public resendAccountCompletionEmail(requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).resendAccountCompletionEmail(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resend Order Confirmation Email
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public resendOrderConfirmationEmail(requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).resendOrderConfirmationEmail(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Order
     * @param {string} orderNumber 
     * @param {OrderUpdateIn} orderUpdateIn 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public updateOrder(orderNumber: string, orderUpdateIn: OrderUpdateIn, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).updateOrder(orderNumber, orderUpdateIn, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PaymentsApi - axios parameter creator
 * @export
 */
export const PaymentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Payments Summary
         * @param {string} username 
         * @param {string | null} [orderNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsSummary: async (username: string, orderNumber?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('paymentsSummary', 'username', username)
            const localVarPath = `/payments/{username}/`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required

            if (orderNumber !== undefined) {
                localVarQueryParameter['order_number'] = orderNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Refund Charge
         * @param {string} chargeId 
         * @param {string} username 
         * @param {number | null} [refundAmount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refundCharge: async (chargeId: string, username: string, refundAmount?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chargeId' is not null or undefined
            assertParamExists('refundCharge', 'chargeId', chargeId)
            // verify required parameter 'username' is not null or undefined
            assertParamExists('refundCharge', 'username', username)
            const localVarPath = `/payments/{charge_id}/refund`
                .replace(`{${"charge_id"}}`, encodeURIComponent(String(chargeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }

            if (refundAmount !== undefined) {
                localVarQueryParameter['refund_amount'] = refundAmount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentsApi - functional programming interface
 * @export
 */
export const PaymentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Payments Summary
         * @param {string} username 
         * @param {string | null} [orderNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsSummary(username: string, orderNumber?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentsSummaryOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsSummary(username, orderNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.paymentsSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Refund Charge
         * @param {string} chargeId 
         * @param {string} username 
         * @param {number | null} [refundAmount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refundCharge(chargeId: string, username: string, refundAmount?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RefundChargeOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refundCharge(chargeId, username, refundAmount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.refundCharge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PaymentsApi - factory interface
 * @export
 */
export const PaymentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentsApiFp(configuration)
    return {
        /**
         * 
         * @summary Payments Summary
         * @param {string} username 
         * @param {string | null} [orderNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsSummary(username: string, orderNumber?: string | null, options?: any): AxiosPromise<PaymentsSummaryOut> {
            return localVarFp.paymentsSummary(username, orderNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Refund Charge
         * @param {string} chargeId 
         * @param {string} username 
         * @param {number | null} [refundAmount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refundCharge(chargeId: string, username: string, refundAmount?: number | null, options?: any): AxiosPromise<RefundChargeOut> {
            return localVarFp.refundCharge(chargeId, username, refundAmount, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentsApi - object-oriented interface
 * @export
 * @class PaymentsApi
 * @extends {BaseAPI}
 */
export class PaymentsApi extends BaseAPI {
    /**
     * 
     * @summary Payments Summary
     * @param {string} username 
     * @param {string | null} [orderNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public paymentsSummary(username: string, orderNumber?: string | null, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).paymentsSummary(username, orderNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Refund Charge
     * @param {string} chargeId 
     * @param {string} username 
     * @param {number | null} [refundAmount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public refundCharge(chargeId: string, username: string, refundAmount?: number | null, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).refundCharge(chargeId, username, refundAmount, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PriceApi - axios parameter creator
 * @export
 */
export const PriceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Prices By Country
         * @param {string} countryCode 
         * @param {Array<string> | null} [lookup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPricesByCountry: async (countryCode: string, lookup?: Array<string> | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'countryCode' is not null or undefined
            assertParamExists('getPricesByCountry', 'countryCode', countryCode)
            const localVarPath = `/price/{country_code}/`
                .replace(`{${"country_code"}}`, encodeURIComponent(String(countryCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required

            if (lookup) {
                localVarQueryParameter['lookup'] = lookup;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Prices V2
         * @param {ListPricesV2CountryCodeEnum} countryCode 
         * @param {Array<ProductType> | null} [product] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPricesV2: async (countryCode: ListPricesV2CountryCodeEnum, product?: Array<ProductType> | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'countryCode' is not null or undefined
            assertParamExists('listPricesV2', 'countryCode', countryCode)
            const localVarPath = `/v2/prices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required

            if (countryCode !== undefined) {
                localVarQueryParameter['country_code'] = countryCode;
            }

            if (product) {
                localVarQueryParameter['product'] = product;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PriceApi - functional programming interface
 * @export
 */
export const PriceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PriceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Prices By Country
         * @param {string} countryCode 
         * @param {Array<string> | null} [lookup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPricesByCountry(countryCode: string, lookup?: Array<string> | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Price>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPricesByCountry(countryCode, lookup, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PriceApi.getPricesByCountry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Prices V2
         * @param {ListPricesV2CountryCodeEnum} countryCode 
         * @param {Array<ProductType> | null} [product] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPricesV2(countryCode: ListPricesV2CountryCodeEnum, product?: Array<ProductType> | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPricesV2Out>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPricesV2(countryCode, product, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PriceApi.listPricesV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PriceApi - factory interface
 * @export
 */
export const PriceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PriceApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Prices By Country
         * @param {string} countryCode 
         * @param {Array<string> | null} [lookup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPricesByCountry(countryCode: string, lookup?: Array<string> | null, options?: any): AxiosPromise<Array<Price>> {
            return localVarFp.getPricesByCountry(countryCode, lookup, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Prices V2
         * @param {ListPricesV2CountryCodeEnum} countryCode 
         * @param {Array<ProductType> | null} [product] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPricesV2(countryCode: ListPricesV2CountryCodeEnum, product?: Array<ProductType> | null, options?: any): AxiosPromise<ListPricesV2Out> {
            return localVarFp.listPricesV2(countryCode, product, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PriceApi - object-oriented interface
 * @export
 * @class PriceApi
 * @extends {BaseAPI}
 */
export class PriceApi extends BaseAPI {
    /**
     * 
     * @summary Get Prices By Country
     * @param {string} countryCode 
     * @param {Array<string> | null} [lookup] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PriceApi
     */
    public getPricesByCountry(countryCode: string, lookup?: Array<string> | null, options?: RawAxiosRequestConfig) {
        return PriceApiFp(this.configuration).getPricesByCountry(countryCode, lookup, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Prices V2
     * @param {ListPricesV2CountryCodeEnum} countryCode 
     * @param {Array<ProductType> | null} [product] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PriceApi
     */
    public listPricesV2(countryCode: ListPricesV2CountryCodeEnum, product?: Array<ProductType> | null, options?: RawAxiosRequestConfig) {
        return PriceApiFp(this.configuration).listPricesV2(countryCode, product, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListPricesV2CountryCodeEnum = {
    Gb: 'GB',
    Us: 'US'
} as const;
export type ListPricesV2CountryCodeEnum = typeof ListPricesV2CountryCodeEnum[keyof typeof ListPricesV2CountryCodeEnum];


/**
 * SelfCancellationApi - axios parameter creator
 * @export
 */
export const SelfCancellationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Cancellation Url
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCancellationUrl: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getCancellationUrl', 'username', username)
            const localVarPath = `/self-cancellation/url/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SelfCancellationApi - functional programming interface
 * @export
 */
export const SelfCancellationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SelfCancellationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Cancellation Url
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCancellationUrl(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SelfCancellationUrl>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCancellationUrl(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SelfCancellationApi.getCancellationUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SelfCancellationApi - factory interface
 * @export
 */
export const SelfCancellationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SelfCancellationApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Cancellation Url
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCancellationUrl(username: string, options?: any): AxiosPromise<SelfCancellationUrl> {
            return localVarFp.getCancellationUrl(username, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SelfCancellationApi - object-oriented interface
 * @export
 * @class SelfCancellationApi
 * @extends {BaseAPI}
 */
export class SelfCancellationApi extends BaseAPI {
    /**
     * 
     * @summary Get Cancellation Url
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SelfCancellationApi
     */
    public getCancellationUrl(username: string, options?: RawAxiosRequestConfig) {
        return SelfCancellationApiFp(this.configuration).getCancellationUrl(username, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SelfServeApi - axios parameter creator
 * @export
 */
export const SelfServeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Membership
         * @param {string} orderNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMembership: async (orderNumber: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderNumber' is not null or undefined
            assertParamExists('getMembership', 'orderNumber', orderNumber)
            const localVarPath = `/self-serve/membership/{order_number}`
                .replace(`{${"order_number"}}`, encodeURIComponent(String(orderNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Self Cancel Membership Auto Renewal
         * @param {string} orderNumber 
         * @param {MembershipAutoRenewalSelfCancellationIn} membershipAutoRenewalSelfCancellationIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfCancelMembershipAutoRenewal: async (orderNumber: string, membershipAutoRenewalSelfCancellationIn: MembershipAutoRenewalSelfCancellationIn, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderNumber' is not null or undefined
            assertParamExists('selfCancelMembershipAutoRenewal', 'orderNumber', orderNumber)
            // verify required parameter 'membershipAutoRenewalSelfCancellationIn' is not null or undefined
            assertParamExists('selfCancelMembershipAutoRenewal', 'membershipAutoRenewalSelfCancellationIn', membershipAutoRenewalSelfCancellationIn)
            const localVarPath = `/self-serve/membership/{order_number}/cancel`
                .replace(`{${"order_number"}}`, encodeURIComponent(String(orderNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(membershipAutoRenewalSelfCancellationIn, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This is a test endpoint to add free months to a membership.
         * @summary Test
         * @param {string} orderNumber 
         * @param {RewardReason} rewardReason 
         * @param {number} [monthsToAdd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        test: async (orderNumber: string, rewardReason: RewardReason, monthsToAdd?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderNumber' is not null or undefined
            assertParamExists('test', 'orderNumber', orderNumber)
            // verify required parameter 'rewardReason' is not null or undefined
            assertParamExists('test', 'rewardReason', rewardReason)
            const localVarPath = `/self-serve/test/{order_number}`
                .replace(`{${"order_number"}}`, encodeURIComponent(String(orderNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required

            if (rewardReason !== undefined) {
                localVarQueryParameter['reward_reason'] = rewardReason;
            }

            if (monthsToAdd !== undefined) {
                localVarQueryParameter['months_to_add'] = monthsToAdd;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SelfServeApi - functional programming interface
 * @export
 */
export const SelfServeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SelfServeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Membership
         * @param {string} orderNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMembership(orderNumber: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MembershipOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMembership(orderNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SelfServeApi.getMembership']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Self Cancel Membership Auto Renewal
         * @param {string} orderNumber 
         * @param {MembershipAutoRenewalSelfCancellationIn} membershipAutoRenewalSelfCancellationIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async selfCancelMembershipAutoRenewal(orderNumber: string, membershipAutoRenewalSelfCancellationIn: MembershipAutoRenewalSelfCancellationIn, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AutoRenewalCancelOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.selfCancelMembershipAutoRenewal(orderNumber, membershipAutoRenewalSelfCancellationIn, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SelfServeApi.selfCancelMembershipAutoRenewal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This is a test endpoint to add free months to a membership.
         * @summary Test
         * @param {string} orderNumber 
         * @param {RewardReason} rewardReason 
         * @param {number} [monthsToAdd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async test(orderNumber: string, rewardReason: RewardReason, monthsToAdd?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferralPhase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.test(orderNumber, rewardReason, monthsToAdd, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SelfServeApi.test']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SelfServeApi - factory interface
 * @export
 */
export const SelfServeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SelfServeApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Membership
         * @param {string} orderNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMembership(orderNumber: string, options?: any): AxiosPromise<MembershipOut> {
            return localVarFp.getMembership(orderNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Self Cancel Membership Auto Renewal
         * @param {string} orderNumber 
         * @param {MembershipAutoRenewalSelfCancellationIn} membershipAutoRenewalSelfCancellationIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfCancelMembershipAutoRenewal(orderNumber: string, membershipAutoRenewalSelfCancellationIn: MembershipAutoRenewalSelfCancellationIn, options?: any): AxiosPromise<AutoRenewalCancelOut> {
            return localVarFp.selfCancelMembershipAutoRenewal(orderNumber, membershipAutoRenewalSelfCancellationIn, options).then((request) => request(axios, basePath));
        },
        /**
         * This is a test endpoint to add free months to a membership.
         * @summary Test
         * @param {string} orderNumber 
         * @param {RewardReason} rewardReason 
         * @param {number} [monthsToAdd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        test(orderNumber: string, rewardReason: RewardReason, monthsToAdd?: number, options?: any): AxiosPromise<ReferralPhase> {
            return localVarFp.test(orderNumber, rewardReason, monthsToAdd, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SelfServeApi - object-oriented interface
 * @export
 * @class SelfServeApi
 * @extends {BaseAPI}
 */
export class SelfServeApi extends BaseAPI {
    /**
     * 
     * @summary Get Membership
     * @param {string} orderNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SelfServeApi
     */
    public getMembership(orderNumber: string, options?: RawAxiosRequestConfig) {
        return SelfServeApiFp(this.configuration).getMembership(orderNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Self Cancel Membership Auto Renewal
     * @param {string} orderNumber 
     * @param {MembershipAutoRenewalSelfCancellationIn} membershipAutoRenewalSelfCancellationIn 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SelfServeApi
     */
    public selfCancelMembershipAutoRenewal(orderNumber: string, membershipAutoRenewalSelfCancellationIn: MembershipAutoRenewalSelfCancellationIn, options?: RawAxiosRequestConfig) {
        return SelfServeApiFp(this.configuration).selfCancelMembershipAutoRenewal(orderNumber, membershipAutoRenewalSelfCancellationIn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This is a test endpoint to add free months to a membership.
     * @summary Test
     * @param {string} orderNumber 
     * @param {RewardReason} rewardReason 
     * @param {number} [monthsToAdd] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SelfServeApi
     */
    public test(orderNumber: string, rewardReason: RewardReason, monthsToAdd?: number, options?: RawAxiosRequestConfig) {
        return SelfServeApiFp(this.configuration).test(orderNumber, rewardReason, monthsToAdd, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StripeApi - axios parameter creator
 * @export
 */
export const StripeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Receive New Webhook Event
         * @param {string} stripeCountry 
         * @param {StripeApiVersion} [apiVersion] 
         * @param {string} [stripeSignature] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveNewWebhookEvent: async (stripeCountry: string, apiVersion?: StripeApiVersion, stripeSignature?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stripeCountry' is not null or undefined
            assertParamExists('receiveNewWebhookEvent', 'stripeCountry', stripeCountry)
            const localVarPath = `/webhook/stripe/{stripe_country}/`
                .replace(`{${"stripe_country"}}`, encodeURIComponent(String(stripeCountry)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required

            if (apiVersion !== undefined) {
                localVarQueryParameter['api_version'] = apiVersion;
            }

            if (stripeSignature != null) {
                localVarHeaderParameter['stripe-signature'] = String(stripeSignature);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StripeApi - functional programming interface
 * @export
 */
export const StripeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StripeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Receive New Webhook Event
         * @param {string} stripeCountry 
         * @param {StripeApiVersion} [apiVersion] 
         * @param {string} [stripeSignature] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receiveNewWebhookEvent(stripeCountry: string, apiVersion?: StripeApiVersion, stripeSignature?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receiveNewWebhookEvent(stripeCountry, apiVersion, stripeSignature, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StripeApi.receiveNewWebhookEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StripeApi - factory interface
 * @export
 */
export const StripeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StripeApiFp(configuration)
    return {
        /**
         * 
         * @summary Receive New Webhook Event
         * @param {string} stripeCountry 
         * @param {StripeApiVersion} [apiVersion] 
         * @param {string} [stripeSignature] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveNewWebhookEvent(stripeCountry: string, apiVersion?: StripeApiVersion, stripeSignature?: string, options?: any): AxiosPromise<any> {
            return localVarFp.receiveNewWebhookEvent(stripeCountry, apiVersion, stripeSignature, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StripeApi - object-oriented interface
 * @export
 * @class StripeApi
 * @extends {BaseAPI}
 */
export class StripeApi extends BaseAPI {
    /**
     * 
     * @summary Receive New Webhook Event
     * @param {string} stripeCountry 
     * @param {StripeApiVersion} [apiVersion] 
     * @param {string} [stripeSignature] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    public receiveNewWebhookEvent(stripeCountry: string, apiVersion?: StripeApiVersion, stripeSignature?: string, options?: RawAxiosRequestConfig) {
        return StripeApiFp(this.configuration).receiveNewWebhookEvent(stripeCountry, apiVersion, stripeSignature, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SubscriptionApi - axios parameter creator
 * @export
 */
export const SubscriptionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Subscription Status
         * @param {string} fromUtc 
         * @param {string} toUtc 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionStatus: async (fromUtc: string, toUtc: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fromUtc' is not null or undefined
            assertParamExists('getSubscriptionStatus', 'fromUtc', fromUtc)
            // verify required parameter 'toUtc' is not null or undefined
            assertParamExists('getSubscriptionStatus', 'toUtc', toUtc)
            const localVarPath = `/subscription/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required

            if (fromUtc !== undefined) {
                localVarQueryParameter['from_utc'] = (fromUtc as any instanceof Date) ?
                    (fromUtc as any).toISOString() :
                    fromUtc;
            }

            if (toUtc !== undefined) {
                localVarQueryParameter['to_utc'] = (toUtc as any instanceof Date) ?
                    (toUtc as any).toISOString() :
                    toUtc;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubscriptionApi - functional programming interface
 * @export
 */
export const SubscriptionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubscriptionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Subscription Status
         * @param {string} fromUtc 
         * @param {string} toUtc 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubscriptionStatus(fromUtc: string, toUtc: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubscriptionStatus(fromUtc, toUtc, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.getSubscriptionStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SubscriptionApi - factory interface
 * @export
 */
export const SubscriptionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubscriptionApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Subscription Status
         * @param {string} fromUtc 
         * @param {string} toUtc 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionStatus(fromUtc: string, toUtc: string, options?: any): AxiosPromise<any> {
            return localVarFp.getSubscriptionStatus(fromUtc, toUtc, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SubscriptionApi - object-oriented interface
 * @export
 * @class SubscriptionApi
 * @extends {BaseAPI}
 */
export class SubscriptionApi extends BaseAPI {
    /**
     * 
     * @summary Get Subscription Status
     * @param {string} fromUtc 
     * @param {string} toUtc 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public getSubscriptionStatus(fromUtc: string, toUtc: string, options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).getSubscriptionStatus(fromUtc, toUtc, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SubscriptionPortalApi - axios parameter creator
 * @export
 */
export const SubscriptionPortalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cancel Auto Renewal
         * @param {AutoRenewalCancelIn} autoRenewalCancelIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAutoRenewal: async (autoRenewalCancelIn: AutoRenewalCancelIn, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'autoRenewalCancelIn' is not null or undefined
            assertParamExists('cancelAutoRenewal', 'autoRenewalCancelIn', autoRenewalCancelIn)
            const localVarPath = `/subscription-portal/auto-renewal/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(autoRenewalCancelIn, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel Subscription
         * @param {SubscriptionCancelIn} subscriptionCancelIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscription: async (subscriptionCancelIn: SubscriptionCancelIn, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionCancelIn' is not null or undefined
            assertParamExists('cancelSubscription', 'subscriptionCancelIn', subscriptionCancelIn)
            const localVarPath = `/subscription-portal/subscription/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subscriptionCancelIn, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Cancellation Url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCancellationUrl: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/subscription-portal/cancel/url/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Stripe Portal Url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStripePortalUrl: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/subscription-portal/stripe_portal_url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Customer Subscriptions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomerSubscriptions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/subscription-portal/subscriptions/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pause payment collection for a subscription.  You can specify a resumes_at timestamp to control when payments will resume. If resumes_at is null, the subscription will be paused indefinitely until manually resumed.  Use charge_when_resumed to control whether the customer should be charged immediately when the subscription is resumed.  TODO: The pause functionality will work also for ZOE membership subscriptions - it can be used to stop billing and for generating void or uncollectible invoices, as we\'d like. Due to the interaction with the commitment period in membership-service, additional implementation is likely required to meet full product requirements.
         * @summary Pause Subscription
         * @param {SubscriptionPauseIn} subscriptionPauseIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pauseSubscription: async (subscriptionPauseIn: SubscriptionPauseIn, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionPauseIn' is not null or undefined
            assertParamExists('pauseSubscription', 'subscriptionPauseIn', subscriptionPauseIn)
            const localVarPath = `/subscription-portal/subscription/pause`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subscriptionPauseIn, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unpause Subscription
         * @param {SubscriptionUnpauseIn} subscriptionUnpauseIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unpauseSubscription: async (subscriptionUnpauseIn: SubscriptionUnpauseIn, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionUnpauseIn' is not null or undefined
            assertParamExists('unpauseSubscription', 'subscriptionUnpauseIn', subscriptionUnpauseIn)
            const localVarPath = `/subscription-portal/subscription/unpause`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subscriptionUnpauseIn, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubscriptionPortalApi - functional programming interface
 * @export
 */
export const SubscriptionPortalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubscriptionPortalApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Cancel Auto Renewal
         * @param {AutoRenewalCancelIn} autoRenewalCancelIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelAutoRenewal(autoRenewalCancelIn: AutoRenewalCancelIn, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Daily30AutoRenewalCancelOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelAutoRenewal(autoRenewalCancelIn, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionPortalApi.cancelAutoRenewal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Cancel Subscription
         * @param {SubscriptionCancelIn} subscriptionCancelIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelSubscription(subscriptionCancelIn: SubscriptionCancelIn, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionCancelOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelSubscription(subscriptionCancelIn, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionPortalApi.cancelSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Cancellation Url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCancellationUrl(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SelfCancellationUrl>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCancellationUrl(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionPortalApi.getCancellationUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Stripe Portal Url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStripePortalUrl(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStripePortalUrlOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStripePortalUrl(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionPortalApi.getStripePortalUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Customer Subscriptions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCustomerSubscriptions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCustomerSubscriptionsOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCustomerSubscriptions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionPortalApi.listCustomerSubscriptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Pause payment collection for a subscription.  You can specify a resumes_at timestamp to control when payments will resume. If resumes_at is null, the subscription will be paused indefinitely until manually resumed.  Use charge_when_resumed to control whether the customer should be charged immediately when the subscription is resumed.  TODO: The pause functionality will work also for ZOE membership subscriptions - it can be used to stop billing and for generating void or uncollectible invoices, as we\'d like. Due to the interaction with the commitment period in membership-service, additional implementation is likely required to meet full product requirements.
         * @summary Pause Subscription
         * @param {SubscriptionPauseIn} subscriptionPauseIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pauseSubscription(subscriptionPauseIn: SubscriptionPauseIn, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionPauseOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pauseSubscription(subscriptionPauseIn, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionPortalApi.pauseSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Unpause Subscription
         * @param {SubscriptionUnpauseIn} subscriptionUnpauseIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unpauseSubscription(subscriptionUnpauseIn: SubscriptionUnpauseIn, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionUnpauseOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unpauseSubscription(subscriptionUnpauseIn, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionPortalApi.unpauseSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SubscriptionPortalApi - factory interface
 * @export
 */
export const SubscriptionPortalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubscriptionPortalApiFp(configuration)
    return {
        /**
         * 
         * @summary Cancel Auto Renewal
         * @param {AutoRenewalCancelIn} autoRenewalCancelIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAutoRenewal(autoRenewalCancelIn: AutoRenewalCancelIn, options?: any): AxiosPromise<Daily30AutoRenewalCancelOut> {
            return localVarFp.cancelAutoRenewal(autoRenewalCancelIn, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel Subscription
         * @param {SubscriptionCancelIn} subscriptionCancelIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscription(subscriptionCancelIn: SubscriptionCancelIn, options?: any): AxiosPromise<SubscriptionCancelOut> {
            return localVarFp.cancelSubscription(subscriptionCancelIn, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Cancellation Url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCancellationUrl(options?: any): AxiosPromise<SelfCancellationUrl> {
            return localVarFp.getCancellationUrl(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Stripe Portal Url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStripePortalUrl(options?: any): AxiosPromise<GetStripePortalUrlOut> {
            return localVarFp.getStripePortalUrl(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Customer Subscriptions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomerSubscriptions(options?: any): AxiosPromise<ListCustomerSubscriptionsOut> {
            return localVarFp.listCustomerSubscriptions(options).then((request) => request(axios, basePath));
        },
        /**
         * Pause payment collection for a subscription.  You can specify a resumes_at timestamp to control when payments will resume. If resumes_at is null, the subscription will be paused indefinitely until manually resumed.  Use charge_when_resumed to control whether the customer should be charged immediately when the subscription is resumed.  TODO: The pause functionality will work also for ZOE membership subscriptions - it can be used to stop billing and for generating void or uncollectible invoices, as we\'d like. Due to the interaction with the commitment period in membership-service, additional implementation is likely required to meet full product requirements.
         * @summary Pause Subscription
         * @param {SubscriptionPauseIn} subscriptionPauseIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pauseSubscription(subscriptionPauseIn: SubscriptionPauseIn, options?: any): AxiosPromise<SubscriptionPauseOut> {
            return localVarFp.pauseSubscription(subscriptionPauseIn, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unpause Subscription
         * @param {SubscriptionUnpauseIn} subscriptionUnpauseIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unpauseSubscription(subscriptionUnpauseIn: SubscriptionUnpauseIn, options?: any): AxiosPromise<SubscriptionUnpauseOut> {
            return localVarFp.unpauseSubscription(subscriptionUnpauseIn, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SubscriptionPortalApi - object-oriented interface
 * @export
 * @class SubscriptionPortalApi
 * @extends {BaseAPI}
 */
export class SubscriptionPortalApi extends BaseAPI {
    /**
     * 
     * @summary Cancel Auto Renewal
     * @param {AutoRenewalCancelIn} autoRenewalCancelIn 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionPortalApi
     */
    public cancelAutoRenewal(autoRenewalCancelIn: AutoRenewalCancelIn, options?: RawAxiosRequestConfig) {
        return SubscriptionPortalApiFp(this.configuration).cancelAutoRenewal(autoRenewalCancelIn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel Subscription
     * @param {SubscriptionCancelIn} subscriptionCancelIn 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionPortalApi
     */
    public cancelSubscription(subscriptionCancelIn: SubscriptionCancelIn, options?: RawAxiosRequestConfig) {
        return SubscriptionPortalApiFp(this.configuration).cancelSubscription(subscriptionCancelIn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Cancellation Url
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionPortalApi
     */
    public getCancellationUrl(options?: RawAxiosRequestConfig) {
        return SubscriptionPortalApiFp(this.configuration).getCancellationUrl(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Stripe Portal Url
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionPortalApi
     */
    public getStripePortalUrl(options?: RawAxiosRequestConfig) {
        return SubscriptionPortalApiFp(this.configuration).getStripePortalUrl(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Customer Subscriptions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionPortalApi
     */
    public listCustomerSubscriptions(options?: RawAxiosRequestConfig) {
        return SubscriptionPortalApiFp(this.configuration).listCustomerSubscriptions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Pause payment collection for a subscription.  You can specify a resumes_at timestamp to control when payments will resume. If resumes_at is null, the subscription will be paused indefinitely until manually resumed.  Use charge_when_resumed to control whether the customer should be charged immediately when the subscription is resumed.  TODO: The pause functionality will work also for ZOE membership subscriptions - it can be used to stop billing and for generating void or uncollectible invoices, as we\'d like. Due to the interaction with the commitment period in membership-service, additional implementation is likely required to meet full product requirements.
     * @summary Pause Subscription
     * @param {SubscriptionPauseIn} subscriptionPauseIn 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionPortalApi
     */
    public pauseSubscription(subscriptionPauseIn: SubscriptionPauseIn, options?: RawAxiosRequestConfig) {
        return SubscriptionPortalApiFp(this.configuration).pauseSubscription(subscriptionPauseIn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unpause Subscription
     * @param {SubscriptionUnpauseIn} subscriptionUnpauseIn 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionPortalApi
     */
    public unpauseSubscription(subscriptionUnpauseIn: SubscriptionUnpauseIn, options?: RawAxiosRequestConfig) {
        return SubscriptionPortalApiFp(this.configuration).unpauseSubscription(subscriptionUnpauseIn, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * V2Api - axios parameter creator
 * @export
 */
export const V2ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cancel Order
         * @param {string} orderNumber 
         * @param {PaymentErrorDetailsV2} [paymentErrorDetailsV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrder: async (orderNumber: string, paymentErrorDetailsV2?: PaymentErrorDetailsV2, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderNumber' is not null or undefined
            assertParamExists('cancelOrder', 'orderNumber', orderNumber)
            const localVarPath = `/checkout/v2/orders/{order_number}/cancel`
                .replace(`{${"order_number"}}`, encodeURIComponent(String(orderNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentErrorDetailsV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create And Finalize Order
         * @param {CheckoutPurchaseInV2} checkoutPurchaseInV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAndFinalizeOrder: async (checkoutPurchaseInV2: CheckoutPurchaseInV2, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checkoutPurchaseInV2' is not null or undefined
            assertParamExists('createAndFinalizeOrder', 'checkoutPurchaseInV2', checkoutPurchaseInV2)
            const localVarPath = `/checkout/v2/orders/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkoutPurchaseInV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create And Finalize Supplementary Order
         * @param {string} username 
         * @param {CheckoutSupplementaryPurchaseInV2} checkoutSupplementaryPurchaseInV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAndFinalizeSupplementaryOrder: async (username: string, checkoutSupplementaryPurchaseInV2: CheckoutSupplementaryPurchaseInV2, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('createAndFinalizeSupplementaryOrder', 'username', username)
            // verify required parameter 'checkoutSupplementaryPurchaseInV2' is not null or undefined
            assertParamExists('createAndFinalizeSupplementaryOrder', 'checkoutSupplementaryPurchaseInV2', checkoutSupplementaryPurchaseInV2)
            const localVarPath = `/checkout/v2/orders/supplementary/customer/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkoutSupplementaryPurchaseInV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Customer Details
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDetails: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getCustomerDetails', 'username', username)
            const localVarPath = `/checkout/v2/customer_details/{username}/`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Discount Data
         * @param {string} promotionCode 
         * @param {string} stripeCountry 
         * @param {Array<string> | null} [onlyApplyToProducts] List of stripe product names that the promotion code is allowed to be used with, None means no restriction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscountData: async (promotionCode: string, stripeCountry: string, onlyApplyToProducts?: Array<string> | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'promotionCode' is not null or undefined
            assertParamExists('getDiscountData', 'promotionCode', promotionCode)
            // verify required parameter 'stripeCountry' is not null or undefined
            assertParamExists('getDiscountData', 'stripeCountry', stripeCountry)
            const localVarPath = `/checkout/v2/promotion-code/{stripe_country}/{promotion_code}/`
                .replace(`{${"promotion_code"}}`, encodeURIComponent(String(promotionCode)))
                .replace(`{${"stripe_country"}}`, encodeURIComponent(String(stripeCountry)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required

            if (onlyApplyToProducts) {
                localVarQueryParameter['only_apply_to_products'] = onlyApplyToProducts;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Tax Rate By Address
         * @param {string} stripeCountry 
         * @param {number} amount 
         * @param {string} zoeProductId 
         * @param {AddressInV2} addressInV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaxRateByAddress: async (stripeCountry: string, amount: number, zoeProductId: string, addressInV2: AddressInV2, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stripeCountry' is not null or undefined
            assertParamExists('getTaxRateByAddress', 'stripeCountry', stripeCountry)
            // verify required parameter 'amount' is not null or undefined
            assertParamExists('getTaxRateByAddress', 'amount', amount)
            // verify required parameter 'zoeProductId' is not null or undefined
            assertParamExists('getTaxRateByAddress', 'zoeProductId', zoeProductId)
            // verify required parameter 'addressInV2' is not null or undefined
            assertParamExists('getTaxRateByAddress', 'addressInV2', addressInV2)
            const localVarPath = `/checkout/v2/tax-rate/{stripe_country}/`
                .replace(`{${"stripe_country"}}`, encodeURIComponent(String(stripeCountry)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required

            if (amount !== undefined) {
                localVarQueryParameter['amount'] = amount;
            }

            if (zoeProductId !== undefined) {
                localVarQueryParameter['zoe_product_id'] = zoeProductId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addressInV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Tax Rate By Country
         * @param {string} stripeCountry 
         * @param {number} amount 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaxRateByCountry: async (stripeCountry: string, amount: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stripeCountry' is not null or undefined
            assertParamExists('getTaxRateByCountry', 'stripeCountry', stripeCountry)
            // verify required parameter 'amount' is not null or undefined
            assertParamExists('getTaxRateByCountry', 'amount', amount)
            const localVarPath = `/checkout/v2/tax-rate/{stripe_country}/`
                .replace(`{${"stripe_country"}}`, encodeURIComponent(String(stripeCountry)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required

            if (amount !== undefined) {
                localVarQueryParameter['amount'] = amount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * V2Api - functional programming interface
 * @export
 */
export const V2ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = V2ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Cancel Order
         * @param {string} orderNumber 
         * @param {PaymentErrorDetailsV2} [paymentErrorDetailsV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelOrder(orderNumber: string, paymentErrorDetailsV2?: PaymentErrorDetailsV2, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelOrder(orderNumber, paymentErrorDetailsV2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V2Api.cancelOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create And Finalize Order
         * @param {CheckoutPurchaseInV2} checkoutPurchaseInV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAndFinalizeOrder(checkoutPurchaseInV2: CheckoutPurchaseInV2, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentDetailsV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAndFinalizeOrder(checkoutPurchaseInV2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V2Api.createAndFinalizeOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create And Finalize Supplementary Order
         * @param {string} username 
         * @param {CheckoutSupplementaryPurchaseInV2} checkoutSupplementaryPurchaseInV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAndFinalizeSupplementaryOrder(username: string, checkoutSupplementaryPurchaseInV2: CheckoutSupplementaryPurchaseInV2, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupplementaryOrderPaymentDetailsV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAndFinalizeSupplementaryOrder(username, checkoutSupplementaryPurchaseInV2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V2Api.createAndFinalizeSupplementaryOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Customer Details
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerDetails(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerDetailsWithOffer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerDetails(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V2Api.getCustomerDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Discount Data
         * @param {string} promotionCode 
         * @param {string} stripeCountry 
         * @param {Array<string> | null} [onlyApplyToProducts] List of stripe product names that the promotion code is allowed to be used with, None means no restriction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDiscountData(promotionCode: string, stripeCountry: string, onlyApplyToProducts?: Array<string> | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiscountDataV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDiscountData(promotionCode, stripeCountry, onlyApplyToProducts, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V2Api.getDiscountData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Tax Rate By Address
         * @param {string} stripeCountry 
         * @param {number} amount 
         * @param {string} zoeProductId 
         * @param {AddressInV2} addressInV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTaxRateByAddress(stripeCountry: string, amount: number, zoeProductId: string, addressInV2: AddressInV2, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTaxRateByAddress(stripeCountry, amount, zoeProductId, addressInV2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V2Api.getTaxRateByAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Tax Rate By Country
         * @param {string} stripeCountry 
         * @param {number} amount 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTaxRateByCountry(stripeCountry: string, amount: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTaxRateByCountry(stripeCountry, amount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V2Api.getTaxRateByCountry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * V2Api - factory interface
 * @export
 */
export const V2ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = V2ApiFp(configuration)
    return {
        /**
         * 
         * @summary Cancel Order
         * @param {string} orderNumber 
         * @param {PaymentErrorDetailsV2} [paymentErrorDetailsV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrder(orderNumber: string, paymentErrorDetailsV2?: PaymentErrorDetailsV2, options?: any): AxiosPromise<any> {
            return localVarFp.cancelOrder(orderNumber, paymentErrorDetailsV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create And Finalize Order
         * @param {CheckoutPurchaseInV2} checkoutPurchaseInV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAndFinalizeOrder(checkoutPurchaseInV2: CheckoutPurchaseInV2, options?: any): AxiosPromise<PaymentDetailsV2> {
            return localVarFp.createAndFinalizeOrder(checkoutPurchaseInV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create And Finalize Supplementary Order
         * @param {string} username 
         * @param {CheckoutSupplementaryPurchaseInV2} checkoutSupplementaryPurchaseInV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAndFinalizeSupplementaryOrder(username: string, checkoutSupplementaryPurchaseInV2: CheckoutSupplementaryPurchaseInV2, options?: any): AxiosPromise<SupplementaryOrderPaymentDetailsV2> {
            return localVarFp.createAndFinalizeSupplementaryOrder(username, checkoutSupplementaryPurchaseInV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Customer Details
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDetails(username: string, options?: any): AxiosPromise<CustomerDetailsWithOffer> {
            return localVarFp.getCustomerDetails(username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Discount Data
         * @param {string} promotionCode 
         * @param {string} stripeCountry 
         * @param {Array<string> | null} [onlyApplyToProducts] List of stripe product names that the promotion code is allowed to be used with, None means no restriction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscountData(promotionCode: string, stripeCountry: string, onlyApplyToProducts?: Array<string> | null, options?: any): AxiosPromise<DiscountDataV2> {
            return localVarFp.getDiscountData(promotionCode, stripeCountry, onlyApplyToProducts, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Tax Rate By Address
         * @param {string} stripeCountry 
         * @param {number} amount 
         * @param {string} zoeProductId 
         * @param {AddressInV2} addressInV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaxRateByAddress(stripeCountry: string, amount: number, zoeProductId: string, addressInV2: AddressInV2, options?: any): AxiosPromise<TaxData> {
            return localVarFp.getTaxRateByAddress(stripeCountry, amount, zoeProductId, addressInV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Tax Rate By Country
         * @param {string} stripeCountry 
         * @param {number} amount 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaxRateByCountry(stripeCountry: string, amount: number, options?: any): AxiosPromise<TaxData> {
            return localVarFp.getTaxRateByCountry(stripeCountry, amount, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * V2Api - object-oriented interface
 * @export
 * @class V2Api
 * @extends {BaseAPI}
 */
export class V2Api extends BaseAPI {
    /**
     * 
     * @summary Cancel Order
     * @param {string} orderNumber 
     * @param {PaymentErrorDetailsV2} [paymentErrorDetailsV2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V2Api
     */
    public cancelOrder(orderNumber: string, paymentErrorDetailsV2?: PaymentErrorDetailsV2, options?: RawAxiosRequestConfig) {
        return V2ApiFp(this.configuration).cancelOrder(orderNumber, paymentErrorDetailsV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create And Finalize Order
     * @param {CheckoutPurchaseInV2} checkoutPurchaseInV2 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V2Api
     */
    public createAndFinalizeOrder(checkoutPurchaseInV2: CheckoutPurchaseInV2, options?: RawAxiosRequestConfig) {
        return V2ApiFp(this.configuration).createAndFinalizeOrder(checkoutPurchaseInV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create And Finalize Supplementary Order
     * @param {string} username 
     * @param {CheckoutSupplementaryPurchaseInV2} checkoutSupplementaryPurchaseInV2 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V2Api
     */
    public createAndFinalizeSupplementaryOrder(username: string, checkoutSupplementaryPurchaseInV2: CheckoutSupplementaryPurchaseInV2, options?: RawAxiosRequestConfig) {
        return V2ApiFp(this.configuration).createAndFinalizeSupplementaryOrder(username, checkoutSupplementaryPurchaseInV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Customer Details
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V2Api
     */
    public getCustomerDetails(username: string, options?: RawAxiosRequestConfig) {
        return V2ApiFp(this.configuration).getCustomerDetails(username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Discount Data
     * @param {string} promotionCode 
     * @param {string} stripeCountry 
     * @param {Array<string> | null} [onlyApplyToProducts] List of stripe product names that the promotion code is allowed to be used with, None means no restriction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V2Api
     */
    public getDiscountData(promotionCode: string, stripeCountry: string, onlyApplyToProducts?: Array<string> | null, options?: RawAxiosRequestConfig) {
        return V2ApiFp(this.configuration).getDiscountData(promotionCode, stripeCountry, onlyApplyToProducts, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Tax Rate By Address
     * @param {string} stripeCountry 
     * @param {number} amount 
     * @param {string} zoeProductId 
     * @param {AddressInV2} addressInV2 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V2Api
     */
    public getTaxRateByAddress(stripeCountry: string, amount: number, zoeProductId: string, addressInV2: AddressInV2, options?: RawAxiosRequestConfig) {
        return V2ApiFp(this.configuration).getTaxRateByAddress(stripeCountry, amount, zoeProductId, addressInV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Tax Rate By Country
     * @param {string} stripeCountry 
     * @param {number} amount 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V2Api
     */
    public getTaxRateByCountry(stripeCountry: string, amount: number, options?: RawAxiosRequestConfig) {
        return V2ApiFp(this.configuration).getTaxRateByCountry(stripeCountry, amount, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * V3Api - axios parameter creator
 * @export
 */
export const V3ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cancel Order
         * @param {string} orderNumber 
         * @param {PaymentErrorDetailsV2} [paymentErrorDetailsV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrder: async (orderNumber: string, paymentErrorDetailsV2?: PaymentErrorDetailsV2, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderNumber' is not null or undefined
            assertParamExists('cancelOrder', 'orderNumber', orderNumber)
            const localVarPath = `/checkout/v3/orders/{order_number}/cancel`
                .replace(`{${"order_number"}}`, encodeURIComponent(String(orderNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentErrorDetailsV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create And Finalize Order
         * @param {CheckoutPurchaseInV3} checkoutPurchaseInV3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAndFinalizeOrder: async (checkoutPurchaseInV3: CheckoutPurchaseInV3, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checkoutPurchaseInV3' is not null or undefined
            assertParamExists('createAndFinalizeOrder', 'checkoutPurchaseInV3', checkoutPurchaseInV3)
            const localVarPath = `/checkout/v3/orders/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkoutPurchaseInV3, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * V3Api - functional programming interface
 * @export
 */
export const V3ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = V3ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Cancel Order
         * @param {string} orderNumber 
         * @param {PaymentErrorDetailsV2} [paymentErrorDetailsV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelOrder(orderNumber: string, paymentErrorDetailsV2?: PaymentErrorDetailsV2, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelOrder(orderNumber, paymentErrorDetailsV2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V3Api.cancelOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create And Finalize Order
         * @param {CheckoutPurchaseInV3} checkoutPurchaseInV3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAndFinalizeOrder(checkoutPurchaseInV3: CheckoutPurchaseInV3, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentDetailsV3>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAndFinalizeOrder(checkoutPurchaseInV3, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V3Api.createAndFinalizeOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * V3Api - factory interface
 * @export
 */
export const V3ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = V3ApiFp(configuration)
    return {
        /**
         * 
         * @summary Cancel Order
         * @param {string} orderNumber 
         * @param {PaymentErrorDetailsV2} [paymentErrorDetailsV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrder(orderNumber: string, paymentErrorDetailsV2?: PaymentErrorDetailsV2, options?: any): AxiosPromise<any> {
            return localVarFp.cancelOrder(orderNumber, paymentErrorDetailsV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create And Finalize Order
         * @param {CheckoutPurchaseInV3} checkoutPurchaseInV3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAndFinalizeOrder(checkoutPurchaseInV3: CheckoutPurchaseInV3, options?: any): AxiosPromise<PaymentDetailsV3> {
            return localVarFp.createAndFinalizeOrder(checkoutPurchaseInV3, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * V3Api - object-oriented interface
 * @export
 * @class V3Api
 * @extends {BaseAPI}
 */
export class V3Api extends BaseAPI {
    /**
     * 
     * @summary Cancel Order
     * @param {string} orderNumber 
     * @param {PaymentErrorDetailsV2} [paymentErrorDetailsV2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V3Api
     */
    public cancelOrder(orderNumber: string, paymentErrorDetailsV2?: PaymentErrorDetailsV2, options?: RawAxiosRequestConfig) {
        return V3ApiFp(this.configuration).cancelOrder(orderNumber, paymentErrorDetailsV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create And Finalize Order
     * @param {CheckoutPurchaseInV3} checkoutPurchaseInV3 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V3Api
     */
    public createAndFinalizeOrder(checkoutPurchaseInV3: CheckoutPurchaseInV3, options?: RawAxiosRequestConfig) {
        return V3ApiFp(this.configuration).createAndFinalizeOrder(checkoutPurchaseInV3, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WebhookApi - axios parameter creator
 * @export
 */
export const WebhookApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Receive New Webhook Event
         * @param {string} stripeCountry 
         * @param {StripeApiVersion} [apiVersion] 
         * @param {string} [stripeSignature] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveNewWebhookEvent: async (stripeCountry: string, apiVersion?: StripeApiVersion, stripeSignature?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stripeCountry' is not null or undefined
            assertParamExists('receiveNewWebhookEvent', 'stripeCountry', stripeCountry)
            const localVarPath = `/webhook/stripe/{stripe_country}/`
                .replace(`{${"stripe_country"}}`, encodeURIComponent(String(stripeCountry)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required

            if (apiVersion !== undefined) {
                localVarQueryParameter['api_version'] = apiVersion;
            }

            if (stripeSignature != null) {
                localVarHeaderParameter['stripe-signature'] = String(stripeSignature);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebhookApi - functional programming interface
 * @export
 */
export const WebhookApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebhookApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Receive New Webhook Event
         * @param {string} stripeCountry 
         * @param {StripeApiVersion} [apiVersion] 
         * @param {string} [stripeSignature] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receiveNewWebhookEvent(stripeCountry: string, apiVersion?: StripeApiVersion, stripeSignature?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receiveNewWebhookEvent(stripeCountry, apiVersion, stripeSignature, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhookApi.receiveNewWebhookEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WebhookApi - factory interface
 * @export
 */
export const WebhookApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebhookApiFp(configuration)
    return {
        /**
         * 
         * @summary Receive New Webhook Event
         * @param {string} stripeCountry 
         * @param {StripeApiVersion} [apiVersion] 
         * @param {string} [stripeSignature] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveNewWebhookEvent(stripeCountry: string, apiVersion?: StripeApiVersion, stripeSignature?: string, options?: any): AxiosPromise<any> {
            return localVarFp.receiveNewWebhookEvent(stripeCountry, apiVersion, stripeSignature, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebhookApi - object-oriented interface
 * @export
 * @class WebhookApi
 * @extends {BaseAPI}
 */
export class WebhookApi extends BaseAPI {
    /**
     * 
     * @summary Receive New Webhook Event
     * @param {string} stripeCountry 
     * @param {StripeApiVersion} [apiVersion] 
     * @param {string} [stripeSignature] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookApi
     */
    public receiveNewWebhookEvent(stripeCountry: string, apiVersion?: StripeApiVersion, stripeSignature?: string, options?: RawAxiosRequestConfig) {
        return WebhookApiFp(this.configuration).receiveNewWebhookEvent(stripeCountry, apiVersion, stripeSignature, options).then((request) => request(this.axios, this.basePath));
    }
}



